/* global firebase, mapboxgl, MapboxGeocoder, turf, L */

const NUXT_PUBLIC_CONFIG = {
  vendors: {
    mapbox: {
      // Public token must start with pk. If left as YOUR_*, the app uses OpenStreetMap + Leaflet instead.
      key: "pk.eyJ1IjoiZ2VydWVzdGV4cHJlc3MiLCJhIjoiY21vZDNocnFjMDNkeDJxc2M4dm9pcWUyMiJ9.3Td_x5dBOzU7c8BUgd8bHg",
      baseUrl: "https://api.mapbox.com",
    },
    firebase: {
      // TODO: paste your firebase config here
      apiKey: "YOUR_FIREBASE_API_KEY",
      authDomain: "YOUR_FIREBASE_AUTH_DOMAIN",
      projectId: "YOUR_FIREBASE_PROJECT_ID",
      storageBucket: "YOUR_FIREBASE_STORAGE_BUCKET",
      messagingSenderId: "YOUR_FIREBASE_MESSAGING_SENDER_ID",
      appId: "YOUR_FIREBASE_APP_ID",
    },
    i18n: {
      baseUrl: "",
      defaultLocale: "de",
      locales: [
        { code: "en", name: "English", language: "" },
        { code: "nl", name: "Nederlands", language: "" },
        { code: "de", name: "Deutsch", language: "" },
      ],
      detectBrowserLanguage: false,
    },
  },
  app: {
    baseURL: "/",
    buildId: "",
    buildAssetsDir: "/_nuxt/",
    cdnURL: "",
  },
};

// Default "Home" map view (Germany).
const HOME_VIEW = {
  center: [10.4515, 51.1657], // Germany (approx. geographic center)
  zoom: 5.6,
};

const STRINGS = {
  en: {
    appTitle: "FLATROOF-PLANNER",
    appTagline: "Plan guardrail runs on the map",
    languageLabel: "Language",
    stepLocation: "Location",
    projectDefaultTitle: "New project",
    projectAddressPlaceholder: "Search on the map for an address",
    panelTitle: "Mark the jobsite boundary",
    panelHelp:
      "Search for an address on the map, zoom in, then draw a line or polygon along the edge that needs guardrail.",
    noDataLine1: "Click on the map to start drawing guardrail sections",
    noDataLine2: "Any subsequent click adds a corner",
    noDataLine3: "Double click to complete the section",
    noDataLine4: "Repeat above steps to add multiple sections",
    noDataLine5: "Clicking anywhere on an existing section adds a point",
    noDataLine6: "Click and drag to move a point",
    noDataShortcutHelp: "Help",
    noDataShortcutUndo: "Undo last point",
    noDataShortcutRemove: "Remove point",
    noDataShortcutRotate: "Rotate map",
    noDataShortcutClickPoint: "Click on point",
    noDataShortcutDrag: "Drag",
    geocoderPlaceholder: "Search address or place…",
    clearBtn: "Clear drawing",
    clearAllDrawings: "Clear all sections",
    saveBtn: "Save to project list",
    savedTitle: "Saved boundaries",
    drawSegmentsTitle: "Sections on map",
    projectSummaryTitle: "Project totals",
    totalProjectLength: "Total length",
    focusSegmentMap: "Focus on map",
    segmentToggleDetails: "Show or hide details",
    saveStatusReady: "Ready.",
    saveStatusNoMap: "Map is not ready yet.",
    saveStatusNoDraw: "Draw tool is not ready yet.",
    saveStatusNoFence: "Draw a polygon first.",
    saveStatusSaved: "Saved.",
    saveStatusSaveFailed: "Save failed:",
    saveStatusNotConfigured: "Firebase not configured. Edit main.js to enable Save.",
    mapProviderOSM: "Ready.",

    mapLoadError: "Map error:",
    mapboxTokenHint: "Set Mapbox public token (pk.…) in main.js or URL ?mapbox_token=pk…",
    fencesLoadFailed: "Load failed:",
    fencesEmpty: "No saved boundaries yet.",
    savedBoundariesNoExtra:
      "Nothing else to show here — the same geometry is already listed under sections on the map.",
    mapSetViewLabel: "Map view",
    fenceItemLabel: "Boundary",
    loadFenceBtn: "Show on map",
    hideFenceBtn: "Hide from map",
    deleteFenceBtn: "Delete",
    deleteFenceConfirm: "Delete this saved boundary?",
    totalCorners: "Total corners",
    totalUprights: "Total uprights",
    totalRailing4m: "Total railing sets 4m",
    totalRailing3m: "Total railing sets 3m",
    uprightsDistance: "Uprights distance",
    spacingUnit: "m",
    sectionNamePlaceholder: "Section 01",
    sendRequestBtn: "Send request",
    saveStatusSavedLocal: "Saved locally (browser). Configure Firebase to sync to cloud.",
    mapLayersTitle: "Map layers",
    mapLayersGroupNl: "Deutschland",
    mapLayersGroupGlobal: "Global",
    layerOrtho2025: "2025 OrthoHR",
    layerOrtho2024: "2024 OrthoHR",
    layerOrtho2023: "2023 OrthoHR",
    layerOrtho2022: "2022 OrthoHR",
    layerBase: "Base",
    layerStreets: "Streets",
    layerSatellite: "Satellite",
    layerSatelliteStreets: "Satellite streets",
    drawModeLabel: "Draw mode",
    drawLine: "Line",
    drawPolygon: "Polygon",
    drawRectangle: "Rectangle",
    helperRadiusLabel: "Helper radius",
    homeBtn: "Home",
    accountToolbar: "Account",
    buildingHeightLabel: "Height of building",
    buildingHeightPlaceholder: "Not known",
    attikaLabel: "Attika present",
    attikaUnknown: "—",
    attikaYes: "Yes",
    attikaNo: "No",
    windZoneLabel: "Wind zone",
    windZoneOpen: "Open lookup",
  },
  nl: {
    appTitle: "FLATROOF-PLANNER",
    appTagline: "Plan vangrail op de kaart",
    languageLabel: "Taal",
    stepLocation: "Locatie",
    projectDefaultTitle: "Nieuw project",
    projectAddressPlaceholder: "Zoek op de kaart naar een adres",
    panelTitle: "Markeer de werf grens",
    panelHelp:
      "Zoek een adres op de kaart, zoom in en teken een lijn of polygoon langs de rand met vangrail.",
    noDataLine1: "Klik op de kaart om te starten met tekenen",
    noDataLine2: "Elke volgende klik voegt een hoek toe",
    noDataLine3: "Dubbelklik om het onderdeel te voltooien",
    noDataLine4: "Herhaal om meerdere onderdelen toe te voegen",
    noDataLine5: "Klik op een bestaande lijn om een punt toe te voegen",
    noDataLine6: "Klik en sleep om een punt te verplaatsen",
    noDataShortcutHelp: "Help",
    noDataShortcutUndo: "Laatste punt ongedaan",
    noDataShortcutRemove: "Punt verwijderen",
    noDataShortcutRotate: "Kaart draaien",
    noDataShortcutClickPoint: "Klik op punt",
    noDataShortcutDrag: "Sleep",
    geocoderPlaceholder: "Zoek adres of plaats…",
    clearBtn: "Tekening wissen",
    clearAllDrawings: "Alle secties wissen",
    saveBtn: "Opslaan in projectlijst",
    savedTitle: "Opgeslagen grenzen",
    drawSegmentsTitle: "Secties op de kaart",
    projectSummaryTitle: "Projecttotalen",
    totalProjectLength: "Totale lengte",
    focusSegmentMap: "Toon op kaart",
    segmentToggleDetails: "Details tonen of verbergen",
    saveStatusReady: "Klaar.",
    saveStatusNoMap: "Kaart is nog niet klaar.",
    saveStatusNoDraw: "Tekengereedschap is nog niet klaar.",
    saveStatusNoFence: "Teken eerst een polygoon.",
    saveStatusSaved: "Opgeslagen.",
    saveStatusSaveFailed: "Opslaan mislukt:",
    saveStatusNotConfigured: "Firebase niet ingesteld. Pas main.js aan voor Opslaan.",
    mapProviderOSM: "Klaar.",
    mapLoadError: "Kaartfout:",
    mapboxTokenHint: "Zet Mapbox-token (pk.…) in main.js of ?mapbox_token=pk… in de URL.",
    fencesLoadFailed: "Laden mislukt:",
    fencesEmpty: "Nog geen opgeslagen grenzen.",
    savedBoundariesNoExtra:
      "Niets extra’s — dezelfde geometrie staat al bij de secties op de kaart.",
    mapSetViewLabel: "Kaartweergave",
    fenceItemLabel: "Grens",
    loadFenceBtn: "Toon op kaart",
    hideFenceBtn: "Verberg op kaart",
    deleteFenceBtn: "Verwijderen",
    deleteFenceConfirm: "Deze opgeslagen grens verwijderen?",
    totalCorners: "Totaal hoeken",
    totalUprights: "Totaal staanders",
    totalRailing4m: "Totaal leuningsets 4m",
    totalRailing3m: "Totaal leuningsets 3m",
    uprightsDistance: "Afstand staanders",
    spacingUnit: "m",
    sectionNamePlaceholder: "Sectie 01",
    sendRequestBtn: "Aanvraag versturen",
    saveStatusSavedLocal: "Lokaal opgeslagen (browser). Stel Firebase in voor cloud.",
    mapLayersTitle: "Kaartlagen",
    mapLayersGroupNl: "Deutschland",
    mapLayersGroupGlobal: "Globaal",
    layerOrtho2025: "2025 OrthoHR",
    layerOrtho2024: "2024 OrthoHR",
    layerOrtho2023: "2023 OrthoHR",
    layerOrtho2022: "2022 OrthoHR",
    layerBase: "Basis",
    layerStreets: "Straten",
    layerSatellite: "Satelliet",
    layerSatelliteStreets: "Satelliet + straten",
    drawModeLabel: "Tekenmodus",
    drawLine: "Lijn",
    drawPolygon: "Polygoon",
    drawRectangle: "Rechthoek",
    helperRadiusLabel: "Hulpradius",
    homeBtn: "Home",
    accountToolbar: "Account",
    buildingHeightLabel: "Gebouwhoogte",
    buildingHeightPlaceholder: "Niet bekend",
    attikaLabel: "Attika aanwezig",
    attikaUnknown: "—",
    attikaYes: "Ja",
    attikaNo: "Nee",
    windZoneLabel: "Windzone",
    windZoneOpen: "Open opzoeken",
  },
  de: {
    appTitle: "FLACHDACH-PLANER",
    appTagline: "Geländerverläufe auf der Karte planen",
    languageLabel: "Sprache",
    stepLocation: "Standort",
    projectDefaultTitle: "Neues Projekt",
    projectAddressPlaceholder: "Planen sie ihre Flachdachsicherung und sende sie uns ihre Anfrage",
    panelTitle: "Dachlänge markieren",
    panelHelp:
      "Suchen Sie eine Adresse auf der Karte, zoomen Sie heran und zeichnen Sie Linie oder Polygon entlang der Geländerkante.",
    noDataLine1: "Klicken Sie auf die Karte, um mit dem Zeichnen zu beginnen",
    noDataLine2: "Jeder weitere Klick fügt eine Ecke hinzu",
    noDataLine3: "Doppelklick, um den Abschnitt abzuschließen",
    noDataLine4: "Wiederholen Sie dies für mehrere Abschnitte",
    noDataLine5: "Klick auf eine bestehende Linie fügt einen Punkt hinzu",
    noDataLine6: "Klicken und ziehen, um einen Punkt zu verschieben",
    noDataShortcutHelp: "Hilfe",
    noDataShortcutUndo: "Letzten Punkt rückgängig",
    noDataShortcutRemove: "Punkt entfernen",
    noDataShortcutRotate: "Karte drehen",
    noDataShortcutClickPoint: "Auf Punkt klicken",
    noDataShortcutDrag: "Ziehen",
    geocoderPlaceholder: "Adresse oder Ort suchen…",
    clearBtn: "Zeichnung löschen",
    clearAllDrawings: "Alle Abschnitte löschen",
    saveBtn: "In Projektliste speichern",
    savedTitle: "Gespeicherte Grenzen",
    drawSegmentsTitle: "Abschnitte auf der Karte",
    projectSummaryTitle: "Projektsummen",
    totalProjectLength: "Gesamtlänge",
    focusSegmentMap: "Auf Karte zeigen",
    segmentToggleDetails: "Details ein- oder ausblenden",
    saveStatusReady: "Bereit.",
    saveStatusNoMap: "Karte ist noch nicht bereit.",
    saveStatusNoDraw: "Zeichenwerkzeug ist noch nicht bereit.",
    saveStatusNoFence: "Bitte zuerst ein Polygon zeichnen.",
    saveStatusSaved: "Gespeichert.",
    saveStatusSaveFailed: "Speichern fehlgeschlagen:",
    saveStatusNotConfigured: "Firebase nicht konfiguriert. main.js bearbeiten für Speichern.",
    mapProviderOSM: "Bereit.",
    mapLoadError: "Kartenfehler:",
    mapboxTokenHint: "Mapbox-Token (pk.…) in main.js oder ?mapbox_token=pk… setzen.",
    fencesLoadFailed: "Laden fehlgeschlagen:",
    fencesEmpty: "Noch keine gespeicherten Grenzen.",
    savedBoundariesNoExtra:
      "Keine weiteren Einträge — dieselbe Zeichnung steht bereits oben bei den Abschnitten.",
    mapSetViewLabel: "Kartenansicht",
    fenceItemLabel: "Grenze",
    loadFenceBtn: "Auf Karte anzeigen",
    hideFenceBtn: "Von Karte ausblenden",
    deleteFenceBtn: "Löschen",
    deleteFenceConfirm: "Diese gespeicherte Grenze löschen?",
    totalCorners: "Ecken gesamt",
    totalUprights: "Pfosten gesamt",
    totalRailing4m: "Geländersets 4m gesamt",
    totalRailing3m: "Geländersets 3m gesamt",
    uprightsDistance: "Pfostenabstand",
    spacingUnit: "m",
    sectionNamePlaceholder: "Abschnitt 01",
    sendRequestBtn: "Anfrage senden",
    saveStatusSavedLocal: "Lokal gespeichert (Browser). Firebase für Cloud konfigurieren.",
    mapLayersTitle: "Kartenebenen",
    mapLayersGroupNl: "Deutschland",
    mapLayersGroupGlobal: "Global",
    layerOrtho2025: "2025 OrthoHR",
    layerOrtho2024: "2024 OrthoHR",
    layerOrtho2023: "2023 OrthoHR",
    layerOrtho2022: "2022 OrthoHR",
    layerBase: "Basis",
    layerStreets: "Straßen",
    layerSatellite: "Satellit",
    layerSatelliteStreets: "Satellit + Straßen",
    drawModeLabel: "Zeichenmodus",
    drawLine: "Linie",
    drawPolygon: "Polygon",
    drawRectangle: "Rechteck",
    helperRadiusLabel: "Hilfsradius",
    homeBtn: "Start",
    accountToolbar: "Konto",
    buildingHeightLabel: "Gebäudehöhe",
    buildingHeightPlaceholder: "Gebäudehöhe in m",
    attikaLabel: "Attika vorhanden",
    attikaUnknown: "—",
    attikaYes: "Ja",
    attikaNo: "Nein",
    windZoneLabel: "Windzone",
    windZoneOpen: "Suche öffnen",
  },
};

const LOCAL_FENCES_KEY = "map_fencing_saved_fences";
const SPACING_STORAGE_KEY = "map_fencing_upright_spacing_m";
const DRAFT_FENCE_KEY = "map_fencing_draft_fence";
const SECTION_COUNTER_KEY = "map_fencing_section_counter";
const DRAW_MODE_STORAGE_KEY = "map_fencing_draw_mode";

/** Single stroke width for fence lines (Mapbox `line-width` + Leaflet `weight`). Forced in paint so it always applies. */
const FENCE_DRAW_LINE_WIDTH_PX = 6;
const MAPBOX_DRAW_MIN_VERTEX_RADIUS_PX = 4;
/** Fence geometry palette (bright green lines, soft fill, white/black handles like reference UI). */
const FENCE_DRAW_LINE_COLOR = "#34c759";
const FENCE_DRAW_FILL_OPACITY = 0.25;
const FENCE_DRAW_VERTEX_FILL = "#ffffff";
const FENCE_DRAW_VERTEX_STROKE = "#111111";
const FENCE_DRAW_VERTEX_STROKE_PX = 1;
/** Leaflet.draw rubber-band spacing (px along guide); lower = denser dots. */
const LEAFLET_DRAW_GUIDELINE_PX = 8;

/** Tile URLs — replace nlOrtho year entries with real PDOK WMTS/XYZ templates if you have them. */
const MAP_LAYER_URLS = {
  leaflet: {
    baseLight:
      "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
    streets: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
    satellite:
      "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    satelliteStreetsOpacity: 0.42,
  },
  /** Demo: all years use the same aerial template; swap for PDOK per-year ortho URLs. */
  nlOrtho: {
    2025:
      "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    2024:
      "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    2023:
      "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    2022:
      "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
  },
  mapbox: {
    base: "mapbox://styles/mapbox/light-v11",
    streets: "mapbox://styles/mapbox/streets-v12",
    satellite: "mapbox://styles/mapbox/satellite-v9",
    satelliteStreets: "mapbox://styles/mapbox/satellite-streets-v12",
  },
};

const MAPBOX_ORTHO_SOURCE_ID = "nl-ortho-raster-src";
const MAPBOX_ORTHO_LAYER_ID = "nl-ortho-raster-layer";

// Zoom tuning
// - Mapbox GL supports fractional zoom up to ~22 (style/source dependent).
// - This project previously capped many interactions at zoom 18, making it feel "not enough".
const MAP_MAX_ZOOM = 22;
const MAP_DETAIL_ZOOM = 20;

let uprightSpacingM = 4;
let uprightType = "standard"; // standard, corner, edge
let currentWindZone = null; // z.B. { zone: "III", vb0Ms: 24.5, country: "NL" }
let mapProviderKind = null;
let leafletBasemapMode = "satelliteStreets";
let leafletBaseLayer = null;
let leafletStreetOverlay = null;
let leafletOrthoLayer = null;
let activeNlOrthoYear = null;
let mapLayersBound = false;

const HELPER_RADIUS_STORAGE_KEY = "map_fencing_helper_radius_m";
let helperRadiusM = 2;
let leafletDrawControlRef = null;
let activeLeafletDrawer = null;
let drawToolbarBound = false;
/** Which saved list row is currently shown on the map (`source:docId|localId`), or null. */
let highlightedFenceListKey = null;
let lastFenceListEntries = null;
let lastFenceListDict = null;
/** `m:${mapboxDrawId}` or `l:${leafletIndex}` → expanded body visible */
let segmentFoldOpenByKey = {};
let liveDrawLengthMarker = null;
let liveLeafletLengthMarker = null;
/** Mapbox `Marker` instances for section titles on the map (Protector-style). */
let mapboxSegmentLabelMarkers = [];
/** Leaflet markers for section titles. */
let leafletSegmentLabelMarkers = [];
let segmentLabelRefreshTimer = null;
// Projector binding can happen before the map exists; track per-provider.
let helperProjectorBound = { leaflet: false, mapbox: false };
let lastPointerLngLat = null;
let helpOverlayPinned = false;
let shortcutsBound = false;
let currentDrawMode = "line";

function normalizeDrawMode(mode) {
  const m = typeof mode === "string" ? mode.trim().toLowerCase() : "";
  return m === "polygon" || m === "rectangle" || m === "line" ? m : "line";
}

function getSavedDrawMode() {
  try {
    return normalizeDrawMode(localStorage.getItem(DRAW_MODE_STORAGE_KEY));
  } catch (_) {
    return "line";
  }
}

function setSavedDrawMode(mode) {
  currentDrawMode = normalizeDrawMode(mode);
  try {
    localStorage.setItem(DRAW_MODE_STORAGE_KEY, currentDrawMode);
  } catch (_) {
    /* ignore */
  }
}

function fenceEntryStableKey(entry, idx) {
  if (entry?.source === "firestore" && entry.docId) return `fs:${entry.docId}`;
  if (entry?.source === "local" && entry.localId) return `loc:${entry.localId}`;
  return `i:${idx}`;
}

/** Round coordinates for stable compare (avoids float noise between draw vs saved payload). */
function normalizeGeometrySignature(geom) {
  if (!geom || typeof geom !== "object" || !geom.type || geom.coordinates == null) return "";
  try {
    const g = JSON.parse(JSON.stringify(geom));
    const roundDeep = (arr) => {
      if (!Array.isArray(arr)) return;
      if (arr.length && arr.every((x) => typeof x === "number")) {
        for (let i = 0; i < arr.length; i++) {
          if (typeof arr[i] === "number") arr[i] = Math.round(arr[i] * 1e5) / 1e5;
        }
        return;
      }
      for (const x of arr) roundDeep(x);
    };
    roundDeep(g.coordinates);
    return JSON.stringify(g);
  } catch (_) {
    return "";
  }
}

function geometrySignatureSetFromSavedRoot(gj) {
  if (!gj) return "";
  if (gj.type === "Feature") return normalizeGeometrySignature(gj.geometry);
  if (gj.type === "FeatureCollection") {
    const parts = (gj.features || [])
      .map((f) => normalizeGeometrySignature(f?.geometry))
      .filter(Boolean)
      .sort();
    return parts.join("|");
  }
  if (gj.type && gj.coordinates != null) return normalizeGeometrySignature(gj);
  return "";
}

function geometrySignatureSetFromActiveDraw() {
  const feats = getAllDrawFeatures();
  if (!feats.length) return "";
  const parts = feats.map((f) => normalizeGeometrySignature(f.geometry)).filter(Boolean).sort();
  return parts.join("|");
}

/** Hide a saved row when it is the same geometry as what is already listed under active sections. */
function savedEntryDuplicatesActiveDraw(entry) {
  const savedSig = geometrySignatureSetFromSavedRoot(entry?.geojson);
  if (!savedSig) return false;
  const activeSig = geometrySignatureSetFromActiveDraw();
  if (!activeSig) return false;
  return savedSig === activeSig;
}

function refreshFenceListUI() {
  if (lastFenceListEntries && lastFenceListDict) {
    renderFenceEntries(lastFenceListEntries, lastFenceListDict);
  }
}

/** Firestore/local may store bare Geometry; Mapbox Draw expects Feature / FeatureCollection. */
function normalizeGeojsonForDraw(data) {
  if (!data) return null;
  const t = data.type;
  if (t === "Feature" || t === "FeatureCollection") return data;
  if (
    t === "LineString" ||
    t === "Polygon" ||
    t === "MultiPolygon" ||
    t === "MultiLineString" ||
    t === "GeometryCollection"
  ) {
    const props = data.properties && typeof data.properties === "object" ? data.properties : {};
    return { type: "Feature", properties: props, geometry: data };
  }
  return data;
}

function segmentUiKey(feature, idx) {
  if (draw && feature?.id != null) return `m:${feature.id}`;
  return `l:${idx}`;
}

/** Trailing digits in sectionName (e.g. "Section 03", "Abschnitt 04") for sidebar ordering. */
function sectionNameNumericSuffix(name) {
  const m = String(name || "").trim().match(/(\d+)\s*$/);
  if (!m) return null;
  const n = Number(m[1]);
  return Number.isFinite(n) ? n : null;
}

/** Sidebar list: sort by section number when names follow …NN, else alphabetically. Draw store order is arbitrary. */
function sortDrawFeaturesForDisplay(feats) {
  if (!feats || feats.length < 2) return feats ? feats.slice() : [];
  return feats.slice().sort((a, b) => {
    const na = (a.properties && a.properties.sectionName) || "";
    const nb = (b.properties && b.properties.sectionName) || "";
    const ia = sectionNameNumericSuffix(na);
    const ib = sectionNameNumericSuffix(nb);
    if (ia != null && ib != null && ia !== ib) return ia - ib;
    if (ia != null && ib == null) return -1;
    if (ia == null && ib != null) return 1;
    return String(na).localeCompare(String(nb), undefined, { numeric: true, sensitivity: "base" });
  });
}

function getMapboxDrawFeatureById(id) {
  if (!draw?.getAll) return null;
  const sid = String(id);
  return (draw.getAll().features || []).find((f) => String(f.id) === sid) || null;
}

/**
 * Give every drawn feature an explicit uprightSpacingM so calculations never share the global default
 * after one segment is edited (DOM ids are strings; strict === against Draw ids used to miss matches).
 */
function ensureMapboxDrawSpacingOnFeatures() {
  if (mapProviderKind !== "mapbox" || !draw?.getAll || typeof draw.setFeatureProperty !== "function") return;
  if (!(uprightSpacingM === 3 || uprightSpacingM === 4)) return;
  mapboxExitDrawModeIfNeeded();
  for (const f of getAllDrawFeatures()) {
    if (f?.id == null) continue;
    const p = Number(f.properties?.uprightSpacingM);
    if (p === 3 || p === 4) continue;
    try {
      draw.setFeatureProperty(f.id, "uprightSpacingM", uprightSpacingM);
    } catch (_) {
      /* ignore */
    }
  }
}

function updateMapboxFeatureProperties(id, patch) {
  if (!draw || id == null || !patch || typeof patch !== "object") return;
  mapboxExitDrawModeIfNeeded();
  const f = getMapboxDrawFeatureById(id);
  if (!f?.geometry) return;
  const fid = f.id;

  if (typeof draw.setFeatureProperty === "function") {
    try {
      for (const [k, v] of Object.entries(patch)) {
        if (v === undefined) continue;
        draw.setFeatureProperty(fid, k, v);
      }
    } catch (e) {
      console.warn(e);
    }
    return;
  }

  const oldKey = `m:${fid}`;
  const foldOpen = !!segmentFoldOpenByKey[oldKey];
  const geomSig = normalizeGeometrySignature(f.geometry);
  const beforeIds = new Set((draw.getAll().features || []).map((x) => String(x.id)));
  try {
    delete segmentFoldOpenByKey[oldKey];
    draw.delete(fid);
    mapboxDrawAddCleanFeature(f.geometry, { ...(f.properties || {}), ...patch });
    const after = draw.getAll().features || [];
    let replacement =
      geomSig && after.find((x) => normalizeGeometrySignature(x.geometry) === geomSig);
    if (!replacement) {
      replacement = after.find((x) => !beforeIds.has(String(x.id)));
    }
    if (!replacement && after.length) {
      replacement = after[after.length - 1];
    }
    if (replacement?.id != null && foldOpen) {
      segmentFoldOpenByKey[`m:${replacement.id}`] = true;
    }
  } catch (e) {
    console.warn(e);
  }
}

function leafletLayersInOrder() {
  const layers = [];
  if (leafletDrawnItems) leafletDrawnItems.eachLayer((l) => layers.push(l));
  return layers;
}

function updateLeafletLayerGeojsonAtIndex(idx, patch) {
  const layers = leafletLayersInOrder();
  const layer = layers[idx];
  if (!layer?.toGeoJSON) return;
  const gj = layer.toGeoJSON();
  if (gj.type !== "Feature") return;
  gj.properties = { ...(gj.properties || {}), ...patch };
  try {
    leafletDrawnItems.removeLayer(layer);
  } catch (_) {
    /* ignore */
  }
  const gjLayer = L.geoJSON(gj, {
    style: { color: FENCE_DRAW_LINE_COLOR, weight: FENCE_DRAW_LINE_WIDTH_PX, fillOpacity: FENCE_DRAW_FILL_OPACITY },
  });
  gjLayer.eachLayer((nl) => leafletDrawnItems.addLayer(nl));
}

function removeSegmentByUiKey(key) {
  if (!key) return;
  if (key.startsWith("m:")) {
    const id = key.slice(2);
    try {
      if (draw) draw.delete(id);
    } catch (_) {
      /* ignore */
    }
  } else if (key.startsWith("l:")) {
    const idx = Number(key.slice(2));
    const layers = leafletLayersInOrder();
    const layer = layers[idx];
    if (layer) {
      try {
        leafletDrawnItems.removeLayer(layer);
      } catch (_) {
        /* ignore */
      }
    }
  }
  delete segmentFoldOpenByKey[key];
}

function getSegmentUprightType(f) {
  const t = f?.properties?.uprightType;
  if (["standard", "corner", "edge"].includes(t)) return t;
  return uprightType;
}

async function getWindZoneForLocation(lng, lat) {
  try {
    const response = await fetch(
      `https://calculator.protectorguardrail.com/api/windzone?lon=${lng}&lat=${lat}`
    );
    const data = await response.json();
    currentWindZone = {
      zone: data.zone,
      vb0Ms: data.vb0Ms,
      country: data.country
    };
    console.log("✅ Windzone fetched:", currentWindZone);
    return currentWindZone;
  } catch (e) {
    console.warn("⚠️ Windzone fetch failed:", e);
    return null;
  }
}

function getWindZoneMultiplier(zone) {
  const multipliers = {
    "I": 0.9,
    "II": 1.0,
    "III": 1.1,
    "IV": 1.2
  };
  return multipliers[zone] || 1.0;
}

/** Per-segment post spacing (m); falls back to project default from the summary card. */
function getSegmentUprightSpacingM(f) {
  const p = Number(f?.properties?.uprightSpacingM);
  if (p === 3 || p === 4) return p;
  return uprightSpacingM;
}

function getCalculationsForSingleFeature(f) {
  if (!f || typeof turf === "undefined") return null;
  const info = getFeatureLengthAndCorners(f);
  if (!info) return null;
  const spacingM = getSegmentUprightSpacingM(f);
  let sets4m = 0;
  let sets3m = 0;
  let u = estimateUprightsForFeature(info.lengthM, spacingM, info.vertices, info.isClosedLoop);
// Windzone-Multiplikator anwenden
if (currentWindZone) {
  const windMult = getWindZoneMultiplier(currentWindZone.zone);
  u = Math.ceil(u * windMult);
}
  const uprights = u;
  const bays = Math.max(0, info.isClosedLoop ? u : u - 1);
  if (spacingM === 3) {
    sets3m += bays;
  } else if (spacingM === 4) {
    const s = splitRailingSetsBySpacing(info.lengthM, 4);
    sets4m += s.sets4m;
    sets3m += s.sets3m;
  } else {
    const s = splitRailingSets(info.lengthM);
    sets4m += s.sets4m;
    sets3m += s.sets3m;
  }
  return {
    perimeterM: info.lengthM,
    corners: info.corners,
    uprights,
    sets4m,
    sets3m,
  };
}

function flyMapToFeature(f, leafletIdx) {
  if (!f || typeof turf === "undefined") return;
  try {
    const bb = turf.bbox(f);
    if (!bb || bb.some((x) => !Number.isFinite(x))) return;
    if (mapProviderKind === "mapbox" && map?.fitBounds) {
      map.fitBounds(
        [
          [bb[0], bb[1]],
          [bb[2], bb[3]],
        ],
        { padding: 52, duration: 500, maxZoom: MAP_DETAIL_ZOOM }
      );
      if (draw && f.id != null) {
        try {
          draw.changeMode("simple_select", { featureIds: [f.id] });
        } catch (_) {
          /* ignore */
        }
      }
    } else if (mapProviderKind === "leaflet" && leafletMap) {
      const layers = leafletLayersInOrder();
      const idx =
        leafletIdx != null && Number.isFinite(leafletIdx)
          ? leafletIdx
          : getAllDrawFeatures().findIndex(
              (x) => x === f || (x.geometry === f.geometry && JSON.stringify(x) === JSON.stringify(f))
            );
      const layer = idx >= 0 ? layers[idx] : null;
      const b = layer?.getBounds?.();
      if (b?.isValid?.()) leafletMap.fitBounds(b.pad(0.15), { maxZoom: MAP_DETAIL_ZOOM });
    }
  } catch (_) {
    /* ignore */
  }
}

function ensureLeafletSectionNameOnLayer(layer) {
  if (!layer?.toGeoJSON || !leafletDrawnItems) return;
  const gj = layer.toGeoJSON();
  if (gj.type !== "Feature") return;
  gj.properties = gj.properties || {};
  const p = Number(gj.properties.uprightSpacingM);
  if (p !== 3 && p !== 4) gj.properties.uprightSpacingM = uprightSpacingM;
  if (gj.properties.sectionName && String(gj.properties.sectionName).trim()) return;
  gj.properties.sectionName = nextAutoSectionName();
  try {
    leafletDrawnItems.removeLayer(layer);
  } catch (_) {
    /* ignore */
  }
  const gjLayer = L.geoJSON(gj, {
    style: { color: FENCE_DRAW_LINE_COLOR, weight: FENCE_DRAW_LINE_WIDTH_PX, fillOpacity: FENCE_DRAW_FILL_OPACITY },
  });
  gjLayer.eachLayer((nl) => leafletDrawnItems.addLayer(nl));
}

function lngLatForFeatureLabelAnchor(f) {
  if (!f?.geometry || typeof turf === "undefined") return null;
  try {
    const g = f.geometry;
    if (g.type === "LineString") {
      const pos = normalizeLinePositions(g.coordinates);
      if (!pos || pos.length < 2) return null;
      const line = turf.lineString(pos);
      const len = turf.length(line, { units: "meters" });
      if (typeof turf.along === "function" && Number.isFinite(len) && len > 0) {
        const pt = turf.along(line, len / 2, { units: "meters" });
        return pt.geometry.coordinates;
      }
      return pos[Math.floor(pos.length / 2)];
    }
    if (g.type === "MultiLineString") {
      for (const lineCoords of g.coordinates || []) {
        const pos = normalizeLinePositions(lineCoords);
        if (!pos || pos.length < 2) continue;
        const line = turf.lineString(pos);
        const len = turf.length(line, { units: "meters" });
        if (typeof turf.along === "function" && Number.isFinite(len) && len > 0) {
          return turf.along(line, len / 2, { units: "meters" }).geometry.coordinates;
        }
        return pos[Math.floor(pos.length / 2)];
      }
      return null;
    }
    if (g.type === "Polygon" || g.type === "MultiPolygon") {
      const c = turf.center(f);
      return c?.geometry?.coordinates || null;
    }
  } catch (_) {
    return null;
  }
  return null;
}

function scheduleSegmentLabelRefresh() {
  if (segmentLabelRefreshTimer) clearTimeout(segmentLabelRefreshTimer);
  segmentLabelRefreshTimer = setTimeout(() => {
    segmentLabelRefreshTimer = null;
    try {
      refreshSegmentNameLabelMarkers();
    } catch (_) {
      /* ignore */
    }
  }, 160);
}

function clearSegmentNameLabelMarkers() {
  if (segmentLabelRefreshTimer) {
    clearTimeout(segmentLabelRefreshTimer);
    segmentLabelRefreshTimer = null;
  }
  for (const m of mapboxSegmentLabelMarkers) {
    try {
      m.remove();
    } catch (_) {
      /* ignore */
    }
  }
  mapboxSegmentLabelMarkers = [];
  if (leafletMap) {
    for (const m of leafletSegmentLabelMarkers) {
      try {
        leafletMap.removeLayer(m);
      } catch (_) {
        /* ignore */
      }
    }
  }
  leafletSegmentLabelMarkers = [];
}

function refreshSegmentNameLabelMarkers() {
  clearSegmentNameLabelMarkers();
  if (!projectStarted || !hasMap()) return;
  const feats = sortDrawFeaturesForDisplay(getAllDrawFeatures());
  if (!feats.length) return;
  const dict = STRINGS[appLocale] || STRINGS.en;
  feats.forEach((f, idx) => {
    const label =
      (f.properties && f.properties.sectionName) || `${dict.fenceItemLabel} ${String(idx + 1).padStart(2, "0")}`;
    const ll = lngLatForFeatureLabelAnchor(f);
    if (!ll || !Number.isFinite(ll[0]) || !Number.isFinite(ll[1])) return;
    if (mapProviderKind === "mapbox" && map && typeof mapboxgl !== "undefined") {
      const el = document.createElement("div");
      el.className = "map-segment-name-label";
      el.textContent = label;
      try {
        const m = new mapboxgl.Marker({ element: el, anchor: "center" }).setLngLat(ll).addTo(map);
        mapboxSegmentLabelMarkers.push(m);
      } catch (_) {
        /* ignore */
      }
    } else if (mapProviderKind === "leaflet" && leafletMap && typeof L !== "undefined") {
      const ic = L.divIcon({
        className: "map-segment-name-label-anchor",
        html: `<div class="map-segment-name-label">${escapeHtml(label)}</div>`,
        iconSize: [1, 1],
        iconAnchor: [0, 0],
      });
      try {
        const m = L.marker([ll[1], ll[0]], { icon: ic, interactive: false, keyboard: false });
        m.addTo(leafletMap);
        leafletSegmentLabelMarkers.push(m);
      } catch (_) {
        /* ignore */
      }
    }
  });
}

function renderDrawSegmentsList() {
  const host = document.getElementById("drawSegmentsList");
  const panel = document.getElementById("activeDrawingPanel");
  if (!host || !panel) return;
  const dict = STRINGS[appLocale] || STRINGS.en;
  const feats = sortDrawFeaturesForDisplay(getAllDrawFeatures());
  if (feats.length === 0) {
    host.innerHTML = "";
    return;
  }

  host.innerHTML = feats
    .map((f, idx) => {
      const key = segmentUiKey(f, idx);
      const open = !!segmentFoldOpenByKey[key];
      const name = (f.properties && f.properties.sectionName) || `${dict.fenceItemLabel} ${String(idx + 1).padStart(2, "0")}`;
      const calc = getCalculationsForSingleFeature(f);
      const len = formatFenceLengthCompact(calc?.perimeterM);
      const chev = open ? "mdi-chevron-up" : "mdi-chevron-down";
      const c = calc || { corners: "—", uprights: "—", sets4m: "—", sets3m: "—" };
      const segSp = getSegmentUprightSpacingM(f);
      const spName = `drawSegSp_${idx}`;
      const eyeTitle = dict.loadFenceBtn || dict.focusSegmentMap;
      return `
<div class="draw-segment-card${open ? " is-open" : ""}" data-segment-key="${escapeHtml(key)}">
  <div class="draw-segment-header">
    <span class="draw-segment-accent" aria-hidden="true"></span>
    <input type="text" class="draw-segment-name" maxlength="120" value="${escapeHtml(name)}" data-segment-key="${escapeHtml(key)}" aria-label="${escapeHtml(dict.sectionNamePlaceholder)}" />
    <span class="draw-segment-length">${escapeHtml(len)}</span>
    <button type="button" class="draw-segment-chevron" data-segment-key="${escapeHtml(key)}" title="${escapeHtml(dict.segmentToggleDetails)}" aria-expanded="${open ? "true" : "false"}"><span class="mdi ${chev}" aria-hidden="true"></span></button>
    <button type="button" class="fence-icon-btn fence-icon-btn--view draw-segment-focus" data-segment-key="${escapeHtml(key)}" title="${escapeHtml(eyeTitle)}" aria-label="${escapeHtml(eyeTitle)}"><span class="mdi mdi-eye" aria-hidden="true"></span></button>
    <button type="button" class="fence-icon-btn fence-icon-btn--delete draw-segment-delete" data-segment-key="${escapeHtml(key)}" title="${escapeHtml(dict.deleteFenceBtn)}" aria-label="${escapeHtml(dict.deleteFenceBtn)}"><span class="mdi mdi-trash-can-outline" aria-hidden="true"></span></button>
  </div>
  <div class="draw-segment-body"${open ? "" : " hidden"}>
    <div class="totals-item calculation-item"><span>${escapeHtml(dict.totalCorners)}</span><span class="totals-value">${escapeHtml(String(c.corners))}</span></div>
    <div class="totals-item calculation-item"><span>${escapeHtml(dict.totalUprights)}</span><span class="totals-value">${escapeHtml(String(c.uprights))}</span></div>
    <div class="totals-item calculation-item"><span>${escapeHtml(dict.totalRailing4m)}</span><span class="totals-value">${escapeHtml(String(c.sets4m))}</span></div>
    <div class="totals-item calculation-item"><span>${escapeHtml(dict.totalRailing3m)}</span><span class="totals-value">${escapeHtml(String(c.sets3m))}</span></div>
    <div class="totals-item calculation-item totals-item--spacing draw-segment-spacing-row">
      <span>${escapeHtml(dict.uprightsDistance)}</span>
      <div class="radio-group" role="radiogroup" aria-label="${escapeHtml(dict.uprightsDistance)}">
        <label class="radio-label">
          <input type="radio" class="draw-segment-spacing" name="${spName}" value="3" data-segment-key="${escapeHtml(key)}" ${segSp === 3 ? "checked" : ""} />
          <span>3</span>
        </label>
        <label class="radio-label">
          <input type="radio" class="draw-segment-spacing" name="${spName}" value="4" data-segment-key="${escapeHtml(key)}" ${segSp === 4 ? "checked" : ""} />
          <span>4</span>
        </label>
      </div>
      <span class="value-unit muted">${escapeHtml(dict.spacingUnit)}</span>
    </div>
  </div>
</div>`;
    })
    .join("");

  host.querySelectorAll(".draw-segment-chevron").forEach((btn) => {
    btn.addEventListener("click", (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      const k = btn.getAttribute("data-segment-key");
      if (!k) return;
      const card = btn.closest(".draw-segment-card");
      const body = card?.querySelector(".draw-segment-body");
      if (!card || !body) return;
      segmentFoldOpenByKey[k] = !segmentFoldOpenByKey[k];
      const open = !!segmentFoldOpenByKey[k];
      if (open) body.removeAttribute("hidden");
      else body.setAttribute("hidden", "");
      card.classList.toggle("is-open", open);
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      const ic = btn.querySelector(".mdi");
      if (ic) {
        ic.classList.remove("mdi-chevron-up", "mdi-chevron-down");
        ic.classList.add(open ? "mdi-chevron-up" : "mdi-chevron-down");
      }
    });
  });

  host.querySelectorAll(".draw-segment-delete").forEach((btn) => {
    btn.addEventListener("click", (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      const k = btn.getAttribute("data-segment-key");
      if (!k) return;
      removeSegmentByUiKey(k);
      updateMeasurements();
    });
  });

  host.querySelectorAll(".draw-segment-focus").forEach((btn) => {
    btn.addEventListener("click", (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      const k = btn.getAttribute("data-segment-key");
      if (!k) return;
      const idx = feats.findIndex((f, i) => segmentUiKey(f, i) === k);
      if (idx >= 0) flyMapToFeature(feats[idx], idx);
    });
  });

  host.querySelectorAll(".draw-segment-name").forEach((inp) => {
    inp.addEventListener("change", () => {
      const k = inp.getAttribute("data-segment-key");
      const v = inp.value?.trim() || "";
      if (!k || !v) return;
      if (k.startsWith("m:")) updateMapboxFeatureProperties(k.slice(2), { sectionName: v });
      else if (k.startsWith("l:")) updateLeafletLayerGeojsonAtIndex(Number(k.slice(2)), { sectionName: v });
      updateMeasurements();
      saveDraftFenceSoon();
    });
    inp.addEventListener("click", (ev) => ev.stopPropagation());
  });

  host.querySelectorAll(".draw-segment-spacing").forEach((radio) => {
    radio.addEventListener("click", (ev) => ev.stopPropagation());
    radio.addEventListener("change", () => {
      if (!radio.checked) return;
      const k = radio.getAttribute("data-segment-key");
      const v = Number(radio.value);
      if (!(v === 3 || v === 4) || !k) return;
      if (k.startsWith("m:")) updateMapboxFeatureProperties(k.slice(2), { uprightSpacingM: v });
      else if (k.startsWith("l:")) updateLeafletLayerGeojsonAtIndex(Number(k.slice(2)), { uprightSpacingM: v });
      updateMeasurements();
      saveDraftFenceSoon();
    });
  });
  host.querySelectorAll(".draw-segment-spacing-row .radio-label").forEach((lab) => {
    lab.addEventListener("mousedown", (ev) => ev.stopPropagation());
  });
}

function ensureLiveDrawLengthMarker() {
  if (!map || liveDrawLengthMarker) return;
  const el = document.createElement("div");
  el.className = "map-draw-live-length";
  el.style.display = "none";
  liveDrawLengthMarker = new mapboxgl.Marker({ element: el, anchor: "bottom" }).setLngLat(HOME_VIEW.center).addTo(map);
}

function hideLiveDrawLengthMarker() {
  if (!liveDrawLengthMarker) return;
  liveDrawLengthMarker.getElement().style.display = "none";
}

function syncLiveDrawLengthLabel(lngLat) {
  if (!map || !draw || mapProviderKind !== "mapbox" || typeof turf === "undefined") return;
  ensureLiveDrawLengthMarker();
  const mode = draw.getMode();
  const el = liveDrawLengthMarker.getElement();
  if (!projectStarted || (mode !== "draw_line_string" && mode !== "draw_polygon")) {
    el.style.display = "none";
    return;
  }

  const fc = draw.getAll();
  let lenM = 0;
  let anchor = lngLat;

  if (mode === "draw_line_string") {
    const lines = fc.features.filter((f) => f.geometry?.type === "LineString");
    const f = lines[lines.length - 1];
    const coords = f?.geometry?.coordinates;
    const pos = normalizeLinePositions(coords);
    if (!pos?.length) {
      el.style.display = "none";
      return;
    }
    if (pos.length >= 2) {
      const base = lengthMForLineCoords(coords);
      if (base != null) lenM = base;
    }
    if (lngLat && pos.length >= 1) {
      const a = pos[pos.length - 1];
      lenM += turf.distance(turf.point(a), turf.point([lngLat.lng, lngLat.lat]), { units: "meters" });
    }
    const last = pos[pos.length - 1];
    anchor = lngLat || { lng: last[0], lat: last[1] };
  } else if (mode === "draw_polygon") {
    const polys = fc.features.filter((f) => f.geometry?.type === "Polygon");
    const f = polys[polys.length - 1];
    const ring = f?.geometry?.coordinates?.[0];
    const pos = normalizeLinePositions(ring);
    if (!pos || pos.length < 2) {
      el.style.display = "none";
      return;
    }
    const base = lengthMForLineCoords(ring);
    if (base != null) lenM = base;
    if (lngLat && pos.length >= 1) {
      const a = pos[pos.length - 1];
      lenM += turf.distance(turf.point(a), turf.point([lngLat.lng, lngLat.lat]), { units: "meters" });
    }
    const last = pos[pos.length - 1];
    anchor = lngLat || { lng: last[0], lat: last[1] };
  } else {
    el.style.display = "none";
    return;
  }

  el.textContent = `${lenM.toFixed(1)} m`;
  el.style.display = "block";
  liveDrawLengthMarker.setLngLat(anchor);
}

function ensureLiveLeafletLengthMarker() {
  if (!leafletMap || liveLeafletLengthMarker || typeof L === "undefined") return;
  const ic = L.divIcon({
    className: "map-draw-live-length map-draw-live-length--leaflet",
    iconSize: [1, 1],
  });
  liveLeafletLengthMarker = L.marker(leafletMap.getCenter(), { icon: ic, interactive: false }).addTo(leafletMap);
}

function hideLiveLeafletLengthMarker() {
  if (!liveLeafletLengthMarker) return;
  liveLeafletLengthMarker.getElement().style.display = "none";
}

function syncLiveLeafletDrawLength(latlng) {
  if (!leafletMap || mapProviderKind !== "leaflet" || typeof turf === "undefined" || !activeLeafletDrawer) {
    hideLiveLeafletLengthMarker();
    return;
  }
  let poly = null;
  try {
    poly = activeLeafletDrawer._poly;
  } catch (_) {
    /* ignore */
  }
  const latlngs = poly?.getLatLngs?.();
  if (!latlngs?.length) {
    hideLiveLeafletLengthMarker();
    return;
  }
  const coords = latlngs.map((ll) => [ll.lng, ll.lat]);
  let lenM = 0;
  if (coords.length >= 2) {
    const base = lengthMForLineCoords(coords);
    if (base != null) lenM = base;
  }
  if (latlng && coords.length >= 1) {
    const a = coords[coords.length - 1];
    lenM += turf.distance(turf.point(a), turf.point([latlng.lng, latlng.lat]), { units: "meters" });
  }
  ensureLiveLeafletLengthMarker();
  const el = liveLeafletLengthMarker.getElement();
  el.textContent = `${lenM.toFixed(1)} m`;
  el.style.display = "block";
  liveLeafletLengthMarker.setLatLng(latlng || latlngs[latlngs.length - 1]);
}

const PROJECTOR_SOURCE_ID = "helper-projector-src";
const PROJECTOR_LAYER_OUTER_ID = "helper-projector-outer";
const PROJECTOR_LAYER_INNER_ID = "helper-projector-inner";
const PROJECTOR_LAYER_TICK_ID = "helper-projector-tick";
/** Leaflet pane for helper rings — below default vector overlay so fence lines stay visible. */
const LEAFLET_PROJECTOR_PANE = "mapFenceProjector";
let mapboxProjectorReady = false;
let leafletProjectorOuter = null;
let leafletProjectorInner = null;
let leafletProjectorTick = null;

/** Great-circle distance in metres (for close-loop detection). */
function latLngDistanceM(a, b) {
  if (!a || !b || typeof a.lat !== "number" || typeof b.lat !== "number") return Infinity;
  const R = 6371000;
  const dLat = ((b.lat - a.lat) * Math.PI) / 180;
  const dLng = ((b.lng - a.lng) * Math.PI) / 180;
  const lat1 = (a.lat * Math.PI) / 180;
  const lat2 = (b.lat * Math.PI) / 180;
  const h =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
  return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
}

function shouldShowHelperProjector() {
  if (!document.getElementById("bottomDrawToolbar") || !hasMap()) return false;
  if (!(helperRadiusM > 0)) return false;

  // Show after Start Project (normal mode), but also show while picking a new location
  // so every click previews the projector at the clicked point (reference behavior).
  if (projectStarted) return true;
  return Array.isArray(lastClickedLngLat) && lastClickedLngLat.length === 2;
}

function getProjectorGeoJson(lngLat) {
  if (!lngLat) return null;
  const [lng, lat] = lngLat;
  if (!Number.isFinite(lng) || !Number.isFinite(lat)) return null;

  // Prefer Turf for accurate circles, but don't depend on it being loaded.
  if (typeof turf !== "undefined") {
    const center = turf.point([lng, lat]);
    const outer = turf.circle(center, helperRadiusM / 1000, { steps: 96, units: "kilometers" });
    const inner = turf.circle(center, Math.max(0.5, helperRadiusM * 0.5) / 1000, {
      steps: 72,
      units: "kilometers",
    });

    return turf.featureCollection([
      turf.feature(outer.geometry, { kind: "outer" }),
      turf.feature(inner.geometry, { kind: "inner" }),
    ]);
  }

  // Fallback: approximate circles in degrees (good enough for a small UI projector).
  const circleCoords = (radiusM, steps) => {
    const coords = [];
    const radLat = (lat * Math.PI) / 180;
    const metersPerDegLat = 111_320;
    const metersPerDegLng = Math.max(1, Math.cos(radLat) * 111_320);
    for (let i = 0; i <= steps; i += 1) {
      const a = (i / steps) * Math.PI * 2;
      const dx = Math.cos(a) * radiusM;
      const dy = Math.sin(a) * radiusM;
      coords.push([lng + dx / metersPerDegLng, lat + dy / metersPerDegLat]);
    }
    return coords;
  };

  const outerRing = circleCoords(helperRadiusM, 96);
  const innerRing = circleCoords(Math.max(0.5, helperRadiusM * 0.5), 72);
  return {
    type: "FeatureCollection",
    features: [
      { type: "Feature", properties: { kind: "outer" }, geometry: { type: "Polygon", coordinates: [outerRing] } },
      { type: "Feature", properties: { kind: "inner" }, geometry: { type: "Polygon", coordinates: [innerRing] } },
    ],
  };
}

function updateHelperProjector(lngLat) {
  lastPointerLngLat = lngLat || lastPointerLngLat;
  if (!shouldShowHelperProjector() || !lastPointerLngLat) {
    // Hide
    try {
      if (mapProviderKind === "mapbox" && map && mapboxProjectorReady) {
        if (map.getLayer?.(PROJECTOR_LAYER_OUTER_ID)) map.setLayoutProperty(PROJECTOR_LAYER_OUTER_ID, "visibility", "none");
        if (map.getLayer?.(PROJECTOR_LAYER_INNER_ID)) map.setLayoutProperty(PROJECTOR_LAYER_INNER_ID, "visibility", "none");
        if (map.getLayer?.(PROJECTOR_LAYER_TICK_ID)) map.setLayoutProperty(PROJECTOR_LAYER_TICK_ID, "visibility", "none");
      }
    } catch (_) {
      /* ignore */
    }
    try {
      leafletProjectorOuter?.setStyle?.({ opacity: 0, fillOpacity: 0 });
      leafletProjectorInner?.setStyle?.({ opacity: 0, fillOpacity: 0 });
      leafletProjectorTick?.setStyle?.({ opacity: 0 });
    } catch (_) {
      /* ignore */
    }
    return;
  }

  const fc = getProjectorGeoJson(lastPointerLngLat);
  if (!fc) return;

  if (mapProviderKind === "mapbox" && map) {
    try {
      if (!map.getSource(PROJECTOR_SOURCE_ID)) return;
      map.getSource(PROJECTOR_SOURCE_ID).setData(fc);
      if (map.getLayer?.(PROJECTOR_LAYER_OUTER_ID)) map.setLayoutProperty(PROJECTOR_LAYER_OUTER_ID, "visibility", "visible");
      if (map.getLayer?.(PROJECTOR_LAYER_INNER_ID)) map.setLayoutProperty(PROJECTOR_LAYER_INNER_ID, "visibility", "visible");
      if (map.getLayer?.(PROJECTOR_LAYER_TICK_ID)) map.setLayoutProperty(PROJECTOR_LAYER_TICK_ID, "visibility", "visible");
    } catch (_) {
      /* ignore */
    }
  } else if (mapProviderKind === "leaflet" && leafletMap) {
    try {
      const outer = fc.features.find((f) => f.properties?.kind === "outer");
      const inner = fc.features.find((f) => f.properties?.kind === "inner");
      const tick = fc.features.find((f) => f.properties?.kind === "tick");

      if (outer && leafletProjectorOuter) leafletProjectorOuter.setLatLngs(L.geoJSON(outer).getLayers()[0].getLatLngs());
      if (inner && leafletProjectorInner) leafletProjectorInner.setLatLngs(L.geoJSON(inner).getLayers()[0].getLatLngs());
      if (tick && leafletProjectorTick) {
        leafletProjectorTick.setLatLngs(L.geoJSON(tick).getLayers()[0].getLatLngs());
        leafletProjectorTick?.setStyle?.({ opacity: 1 });
      } else if (leafletProjectorTick) {
        leafletProjectorTick.setLatLngs([]);
        leafletProjectorTick?.setStyle?.({ opacity: 0 });
      }

      leafletProjectorOuter?.setStyle?.({ opacity: 1, fillOpacity: 0 });
      leafletProjectorInner?.setStyle?.({ opacity: 1, fillOpacity: 0 });
    } catch (_) {
      /* ignore */
    }
  }
}

function ensureHelperProjector() {
  if (helperProjectorBound.leaflet && helperProjectorBound.mapbox) return;

  // Update projector even before the user moves the mouse (e.g. first click / first hover).
  const bindImmediatePointerUpdates = (container, toLngLat) => {
    if (!container || container.dataset.mapFenceProjectorImmediate) return;
    container.dataset.mapFenceProjectorImmediate = "1";

    const updateFromEvent = (ev) => {
      try {
        const ll = toLngLat(ev);
        if (ll) updateHelperProjector(ll);
      } catch (_) {
        /* ignore */
      }
    };

    // Capture so draw/edit handles don't block the projector.
    container.addEventListener("pointermove", updateFromEvent, { capture: true, passive: true });
    container.addEventListener("pointerenter", updateFromEvent, { capture: true, passive: true });
    container.addEventListener("pointerdown", updateFromEvent, { capture: true, passive: true });
  };

  // Leaflet projector layers
  const ensureLeaflet = () => {
    if (!leafletMap || typeof L === "undefined") return;
    if (helperProjectorBound.leaflet) return;
    let projPane = leafletMap.getPane(LEAFLET_PROJECTOR_PANE);
    if (!projPane) {
      projPane = leafletMap.createPane(LEAFLET_PROJECTOR_PANE);
      projPane.style.zIndex = "350";
      projPane.style.pointerEvents = "none";
    }
    if (!leafletProjectorOuter) {
      leafletProjectorOuter = L.polygon([], {
        color: "#ffd400",
        weight: 2,
        opacity: 1,
        fill: false,
        dashArray: "10 10",
        interactive: false,
        pane: LEAFLET_PROJECTOR_PANE,
      }).addTo(leafletMap);
    }
    if (!leafletProjectorInner) {
      leafletProjectorInner = L.polygon([], {
        color: "#ffffff",
        weight: 2,
        opacity: 1,
        fill: false,
        dashArray: "7 9",
        interactive: false,
        pane: LEAFLET_PROJECTOR_PANE,
      }).addTo(leafletMap);
    }
    if (!leafletProjectorTick) {
      leafletProjectorTick = L.polyline([], {
        color: "#34c759",
        weight: 5,
        opacity: 1,
        lineCap: "round",
        interactive: false,
        pane: LEAFLET_PROJECTOR_PANE,
      }).addTo(leafletMap);
    }

    leafletMap.on("mousemove", (e) => updateHelperProjector([e.latlng.lng, e.latlng.lat]));
    leafletMap.on("mouseout", () => updateHelperProjector(null));
    bindImmediatePointerUpdates(leafletMap.getContainer?.(), (ev) => {
      const ll = leafletMap.mouseEventToLatLng?.(ev);
      if (!ll) return null;
      return [ll.lng, ll.lat];
    });
    helperProjectorBound.leaflet = true;
  };

  // Mapbox projector source/layers
  const ensureMapbox = () => {
    if (!map) return;
    if (helperProjectorBound.mapbox) return;
    const add = () => {
      if (map.getSource(PROJECTOR_SOURCE_ID)) return;
      map.addSource(PROJECTOR_SOURCE_ID, {
        type: "geojson",
        data: { type: "FeatureCollection", features: [] },
      });
      map.addLayer({
        id: PROJECTOR_LAYER_OUTER_ID,
        type: "line",
        source: PROJECTOR_SOURCE_ID,
        filter: ["==", ["get", "kind"], "outer"],
        paint: {
          "line-color": "#ffd400",
          "line-width": 2,
          "line-dasharray": [2, 2],
        },
        layout: { visibility: "none" },
      });
      map.addLayer({
        id: PROJECTOR_LAYER_INNER_ID,
        type: "line",
        source: PROJECTOR_SOURCE_ID,
        filter: ["==", ["get", "kind"], "inner"],
        paint: {
          "line-color": "#ffffff",
          "line-width": 2,
          "line-dasharray": [1.5, 2.3],
        },
        layout: { visibility: "none" },
      });
      map.addLayer({
        id: PROJECTOR_LAYER_TICK_ID,
        type: "line",
        source: PROJECTOR_SOURCE_ID,
        filter: ["==", ["get", "kind"], "tick"],
        paint: {
          "line-color": "#34c759",
          "line-width": 5,
        },
        layout: { visibility: "none", "line-cap": "round" },
      });
      mapboxProjectorReady = true;

      map.on("mousemove", (e) => updateHelperProjector([e.lngLat.lng, e.lngLat.lat]));
      map.on("mouseout", () => updateHelperProjector(null));
      bindImmediatePointerUpdates(map.getCanvasContainer?.(), (ev) => {
        const cont = map.getCanvasContainer();
        if (!cont) return null;
        const rect = cont.getBoundingClientRect();
        const x = ev.clientX - rect.left;
        const y = ev.clientY - rect.top;
        const ll = map.unproject?.([x, y]);
        if (!ll) return null;
        return [ll.lng, ll.lat];
      });
      helperProjectorBound.mapbox = true;
    };
    if (map.isStyleLoaded?.()) add();
    else map.once("load", add);
  };

  // Try both; whichever provider is active will start updating.
  ensureLeaflet();
  ensureMapbox();
}

function toggleHelpOverlayPinned() {
  helpOverlayPinned = !helpOverlayPinned;
  const el = document.getElementById("noDataHelp");
  if (!el) return;
  // If pinned on: show. If pinned off: will be controlled by calculations.
  if (helpOverlayPinned) el.hidden = false;
  else updateMeasurements();
}

function bindKeyboardShortcuts() {
  if (shortcutsBound) return;
  shortcutsBound = true;

  document.addEventListener("keydown", (e) => {
    if (e.key === "F1") {
      e.preventDefault();
      toggleHelpOverlayPinned();
      return;
    }

    // Ctrl/Cmd + Z -> undo last point while drawing (Leaflet).
    if ((e.ctrlKey || e.metaKey) && (e.key === "z" || e.key === "Z")) {
      if (mapProviderKind === "leaflet" && activeLeafletDrawer && typeof activeLeafletDrawer.deleteLastVertex === "function") {
        e.preventDefault();
        try {
          activeLeafletDrawer.deleteLastVertex();
          updateMeasurements();
        } catch (_) {
          /* ignore */
        }
        return;
      }

      // Mapbox Draw doesn't expose "deleteLastVertex" publicly; keep our own undo snapshots.
      if (mapProviderKind === "mapbox" && draw && typeof draw.set === "function") {
        if (mapboxUndoStack.length >= 2 && !mapboxUndoRestoring) {
          e.preventDefault();
          mapboxUndoRestoring = true;
          try {
            // Drop current snapshot, restore previous.
            mapboxUndoStack.pop();
            const prev = mapboxUndoStack[mapboxUndoStack.length - 1];
            if (prev) draw.set(prev);
            updateMeasurements();
            saveDraftFenceSoon();
          } catch (_) {
            /* ignore */
          } finally {
            // Allow the "draw.update" event triggered by draw.set() to settle.
            setTimeout(() => {
              mapboxUndoRestoring = false;
            }, 50);
          }
        }
      }
    }
  });
}

function snapshotMapboxUndoState() {
  if (mapProviderKind !== "mapbox" || !draw || mapboxUndoRestoring) return;
  try {
    const fc = draw.getAll?.();
    if (!fc || !Array.isArray(fc.features)) return;
    mapboxUndoStack.push(fc);
    if (mapboxUndoStack.length > 60) mapboxUndoStack.splice(0, mapboxUndoStack.length - 60);
  } catch (_) {
    /* ignore */
  }
}

function removeNearestMapboxVertexAt(point, maxPx = 14) {
  if (mapProviderKind !== "mapbox" || !map || !draw || !point) return false;
  const fc = draw.getAll?.();
  if (!fc || !Array.isArray(fc.features) || fc.features.length === 0) return false;

  let best = null;

  const consider = (feature, coordPath, idx, lngLat) => {
    try {
      const p = map.project?.({ lng: lngLat[0], lat: lngLat[1] });
      if (!p) return;
      const dx = p.x - point.x;
      const dy = p.y - point.y;
      const d = Math.sqrt(dx * dx + dy * dy);
      if (d > maxPx) return;
      if (!best || d < best.d) best = { feature, coordPath, idx, d };
    } catch (_) {
      /* ignore */
    }
  };

  for (const f of fc.features) {
    const g = f?.geometry;
    if (!g) continue;

    if (g.type === "LineString" && Array.isArray(g.coordinates)) {
      g.coordinates.forEach((c, i) => consider(f, g.coordinates, i, c));
    } else if (g.type === "Polygon" && Array.isArray(g.coordinates) && Array.isArray(g.coordinates[0])) {
      // Use outer ring only; ignore the closing coordinate when matching/removing.
      const ring = g.coordinates[0];
      const ringLen = ring.length;
      const effectiveLen =
        ringLen >= 2 &&
        ring[0]?.[0] === ring[ringLen - 1]?.[0] &&
        ring[0]?.[1] === ring[ringLen - 1]?.[1]
          ? ringLen - 1
          : ringLen;
      for (let i = 0; i < effectiveLen; i++) consider(f, ring, i, ring[i]);
    }
  }

  if (!best) return false;
  const { feature, coordPath, idx } = best;
  const g = feature.geometry;
  if (!g) return false;

  // Enforce minimum vertices.
  if (g.type === "LineString") {
    if (coordPath.length <= 2) return false;
  } else if (g.type === "Polygon") {
    const ring = coordPath;
    const ringLen = ring.length;
    const isClosed =
      ringLen >= 4 &&
      ring[0]?.[0] === ring[ringLen - 1]?.[0] &&
      ring[0]?.[1] === ring[ringLen - 1]?.[1];
    const uniqueCount = isClosed ? ringLen - 1 : ringLen;
    if (uniqueCount <= 3) return false;
  }

  // Remove.
  coordPath.splice(idx, 1);
  if (g.type === "Polygon") {
    const ring = coordPath;
    const ringLen = ring.length;
    if (ringLen >= 3) {
      const first = ring[0];
      const last = ring[ringLen - 1];
      if (!last || last[0] !== first[0] || last[1] !== first[1]) ring.push([first[0], first[1]]);
    }
  }

  try {
    draw.delete(feature.id);
    mapboxDrawAddCleanFeature(g, feature.properties || {});
    snapshotMapboxUndoState();
    return true;
  } catch (_) {
    return false;
  }
}

function bindHomeButton() {
  const btn = document.getElementById("homeBtn");
  if (!btn || btn.dataset.bound === "1") return;
  btn.dataset.bound = "1";
  btn.addEventListener("click", () => {
    try {
      if (mapProviderKind === "mapbox" && map?.flyTo) {
        map.flyTo({ center: HOME_VIEW.center, zoom: HOME_VIEW.zoom, essential: true });
      } else if (mapProviderKind === "leaflet" && leafletMap?.setView) {
        leafletMap.setView([HOME_VIEW.center[1], HOME_VIEW.center[0]], HOME_VIEW.zoom);
      }
    } catch (_) {
      /* ignore */
    }
  });
}

function removeNearestLeafletVertexAt(latlng, maxPx = 14) {
  if (!leafletMap || !leafletDrawnItems || !latlng) return false;
  const targetPt = leafletMap.latLngToContainerPoint(latlng);

  let best = null;

  const considerLatLng = (layer, path, idx, ll) => {
    const p = leafletMap.latLngToContainerPoint(ll);
    const d = p.distanceTo(targetPt);
    if (d > maxPx) return;
    if (!best || d < best.d) best = { layer, path, idx, d };
  };

  leafletDrawnItems.eachLayer((layer) => {
    if (!layer || typeof layer.getLatLngs !== "function" || typeof layer.setLatLngs !== "function") return;
    const latlngs = layer.getLatLngs();
    if (!Array.isArray(latlngs) || latlngs.length === 0) return;

    // Polygon: [ring[]] or multi rings. Polyline: [latlng...]
    const isNested = Array.isArray(latlngs[0]);
    if (!isNested) {
      latlngs.forEach((ll, i) => considerLatLng(layer, latlngs, i, ll));
      return;
    }

    // Nested
    for (const ring of latlngs) {
      if (!Array.isArray(ring)) continue;
      ring.forEach((ll, i) => considerLatLng(layer, ring, i, ll));
    }
  });

  if (!best) return false;
  const { layer, path, idx } = best;

  // Remove vertex
  try {
    // For closed polygons Leaflet often duplicates first/last; keep minimum 3 unique points.
    const isPolygon = typeof layer instanceof Object && layer instanceof L.Polygon;
    if (path.length <= (isPolygon ? 4 : 2)) return false;
  } catch (_) {
    /* ignore */
  }

  path.splice(idx, 1);
  try {
    layer.setLatLngs(layer.getLatLngs());
  } catch (_) {
    // Some layer types need direct setLatLngs with original structure; fallback is to set current structure
    try {
      layer.setLatLngs(layer.getLatLngs());
    } catch {
      /* ignore */
    }
  }

  return true;
}

function bindLeafletAltClickRemove() {
  if (!leafletMap) return;
  leafletMap.on("click", (e) => {
    const oe = e?.originalEvent;
    if (!oe || !oe.altKey) return;
    const ok = removeNearestLeafletVertexAt(e.latlng);
    if (ok) {
      L.DomEvent?.stop?.(oe);
      updateMeasurements();
    }
  });
}

function bindLeafletCloseLoopAssist() {
  if (!leafletMap) return;
  if (leafletMap._mapFenceCloseAssistBound) return;
  leafletMap._mapFenceCloseAssistBound = true;

  // If the user clicks near the first vertex while drawing, finish the shape.
  // This avoids missing the tiny "first marker" hit area and adding a stray point.
  leafletMap.on("click", (e) => {
    try {
      if (!activeLeafletDrawer || !e?.latlng) return;
      // Leaflet.draw stores markers on the drawer instance.
      const markers = activeLeafletDrawer._markers;
      if (!Array.isArray(markers) || markers.length < 3) return;
      const first = markers[0]?.getLatLng?.();
      if (!first) return;

      const clickPt = leafletMap.latLngToContainerPoint(e.latlng);
      const firstPt = leafletMap.latLngToContainerPoint(first);
      const d = clickPt.distanceTo(firstPt);

      // Tolerance in pixels; tuned to feel like the reference.
      if (d > 18) return;

      // Finish without adding an extra point.
      const oe = e?.originalEvent;
      if (oe) {
        L.DomEvent?.stop?.(oe);
      }

      if (typeof activeLeafletDrawer.completeShape === "function") {
        activeLeafletDrawer.completeShape();
      } else if (typeof activeLeafletDrawer._finishShape === "function") {
        activeLeafletDrawer._finishShape();
      } else if (typeof activeLeafletDrawer.disable === "function") {
        activeLeafletDrawer.disable();
      }
    } catch (_) {
      /* ignore */
    }
  });
}

function bindMapboxRotateGesture() {
  if (!map) return;
  let rotating = false;
  let startX = 0;
  let startBearing = 0;

  const onDown = (ev) => {
    const oe = ev?.originalEvent;
    if (!oe || !oe.altKey || !oe.shiftKey) return;
    rotating = true;
    startX = oe.clientX;
    startBearing = map.getBearing?.() || 0;
    try { map.dragPan?.disable?.(); } catch (_) { /* ignore */ }
  };

  const onMove = (ev) => {
    if (!rotating) return;
    const oe = ev?.originalEvent;
    if (!oe) return;
    const dx = oe.clientX - startX;
    const next = startBearing + dx * 0.35; // deg per px (tuned)
    try { map.setBearing?.(next); } catch (_) { /* ignore */ }
  };

  const onUp = () => {
    if (!rotating) return;
    rotating = false;
    try { map.dragPan?.enable?.(); } catch (_) { /* ignore */ }
  };

  map.on("mousedown", onDown);
  map.on("mousemove", onMove);
  map.on("mouseup", onUp);
  map.on("mouseout", onUp);
}

function getInitialLocale() {
  const saved = localStorage.getItem("map_fencing_locale");
  if (saved) return saved;
  return NUXT_PUBLIC_CONFIG.vendors.i18n.defaultLocale || "en";
}

function escapeHtml(s) {
  return String(s)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

let appLocale = getInitialLocale();
let map = null;
let draw = null;
let firestore = null;
let leafletMap = null;
let leafletDrawnItems = null;
let leafletSearchMarker = null;
let mapboxSearchMarker = null;
let lastClickedLngLat = null;
let projectStarted = false;
let lastResolvedPlaceName = "";
let reversePlaceTimer = null;
let reversePlaceAbort = null;

// Mapbox-specific undo stack (so Ctrl+Z works there too).
let mapboxUndoStack = [];
let mapboxUndoRestoring = false;

let windZoneTimer = null;

let draftSaveTimer = null;
let autoSaveFenceTimer = null;
let autoSaveInFlight = false;
let lastSavedGeometrySig = "";
let lastSavedAtMs = 0;

function isFencingComplete() {
  try {
    const mode = mapProviderKind === "mapbox" && draw?.getMode ? draw.getMode() : null;
    const rawFeatures = draw?.getAll ? (draw.getAll().features || []) : getAllDrawFeatures();
    const features = getAllDrawFeatures().filter((feature) => !isMapboxActiveSketchFeature(feature, mode, rawFeatures));
    return features.some((feature) => {
      const info = getFeatureLengthAndCorners(feature);
      return !!info && Number.isFinite(info.lengthM) && info.lengthM > 0;
    });
  } catch (_) {
    return getAllDrawFeatures().length > 0;
  }
}

function resetCurrentFencingAfterQuote() {
  try {
    stopLeafletDraw();
  } catch (_) {
    /* ignore */
  }
  try {
    draw?.deleteAll?.();
  } catch (_) {
    /* ignore */
  }
  try {
    leafletDrawnItems?.clearLayers?.();
  } catch (_) {
    /* ignore */
  }
  segmentFoldOpenByKey = {};
  projectStarted = false;
  lastClickedLngLat = null;
  lastResolvedPlaceName = "";
  refreshProjectPlaceAddress();
  clearProjectPickMarker();
  updateHelperProjector(null);
  hideLiveDrawLengthMarker();
  hideLiveLeafletLengthMarker();
  try {
    localStorage.removeItem(DRAFT_FENCE_KEY);
  } catch (_) {
    /* ignore */
  }
  updateMeasurements();
  primeDefaultDrawMode();
}

function resetQuoteStateFromSuccessUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get("contact_posted") !== "true") return;
    resetCurrentFencingAfterQuote();
    history.replaceState(null, "", `${window.location.pathname}${window.location.hash || ""}`);
  } catch (_) {
    /* ignore */
  }
}

function updateSendRequestButtonVisibility() {
  const btn = document.getElementById("sendRequestBtn");
  if (!btn) return;
  btn.hidden = !isFencingComplete();
}

function buildContactFenceFields() {
  const address = (lastResolvedPlaceName || "").trim();
  const feats = getAllDrawFeatures();
  if (!feats.length || typeof turf === "undefined") {
    return {
      address: address || "-",
      snapshotUrl: "",
      uprights3m: "-",
      uprights4m: "-",
    };
  }

  const snapshotUrl = (() => {
    // "Full screen" reference image link for emails (Mapbox only).
    if (mapProviderKind !== "mapbox" || !map) return "";
    const token = getEffectiveMapboxToken();
    if (!token) return "";

    // Encode a polyline for Mapbox static overlays.
    const encodePolyline = (coords) => {
      // coords: [[lng,lat], ...]
      const encodeNum = (num) => {
        let n = num < 0 ? ~(num << 1) : num << 1;
        let out = "";
        while (n >= 0x20) {
          out += String.fromCharCode((0x20 | (n & 0x1f)) + 63);
          n >>= 5;
        }
        out += String.fromCharCode(n + 63);
        return out;
      };
      let lastLat = 0;
      let lastLng = 0;
      let result = "";
      for (const c of coords || []) {
        if (!Array.isArray(c) || c.length < 2) continue;
        const lng = Number(c[0]);
        const lat = Number(c[1]);
        if (!Number.isFinite(lng) || !Number.isFinite(lat)) continue;
        const ilat = Math.round(lat * 1e5);
        const ilng = Math.round(lng * 1e5);
        result += encodeNum(ilat - lastLat);
        result += encodeNum(ilng - lastLng);
        lastLat = ilat;
        lastLng = ilng;
      }
      return result;
    };

    const overlayFromFeatures = () => {
      // Build at most a few overlays to keep the URL length reasonable.
      const overlays = [];
      const maxOverlays = 3;
      for (const f of feats) {
        if (!f?.geometry) continue;
        const g = f.geometry;
        let coords = null;
        let isPoly = false;
        if (g.type === "LineString") {
          coords = normalizeLinePositions(g.coordinates);
        } else if (g.type === "Polygon") {
          coords = normalizeLinePositions(g.coordinates?.[0] || []);
          isPoly = true;
        } else if (g.type === "MultiLineString") {
          // Take the longest line for preview.
          let best = null;
          for (const part of g.coordinates || []) {
            const p = normalizeLinePositions(part);
            if (p && (!best || p.length > best.length)) best = p;
          }
          coords = best;
        } else if (g.type === "MultiPolygon") {
          // Take first polygon outer ring.
          coords = normalizeLinePositions(g.coordinates?.[0]?.[0] || []);
          isPoly = true;
        }
        if (!coords || coords.length < 2) continue;
        // Close ring for polygon overlay (Mapbox expects a line; fill works when closed).
        if (isPoly && coords.length >= 3) {
          const a = coords[0];
          const b = coords[coords.length - 1];
          if (a && b && (a[0] !== b[0] || a[1] !== b[1])) coords = [...coords, [a[0], a[1]]];
        }
        const enc = encodePolyline(coords);
        if (!enc) continue;
        // Green stroke. Add subtle fill for polygons.
        const stroke = "34c759";
        const fill = "34c759";
        const strokeWidth = 4;
        const strokeOpacity = 1;
        const fillOpacity = isPoly ? 0.18 : 0;
        const style = `path-${strokeWidth}+${stroke}-${strokeOpacity}+${fill}-${fillOpacity}`;
        // Mapbox Static API expects the encoded polyline string directly in (...) — no `polyline()` wrapper.
        overlays.push(`${style}(${encodeURIComponent(enc)})`);
        if (overlays.length >= maxOverlays) break;
      }
      return overlays.join(",");
    };

    try {
      const c = map.getCenter?.();
      if (!c) return "";
      const lng = Number(c.lng);
      const lat = Number(c.lat);
      const z = Number(map.getZoom?.());
      const b = Number(map.getBearing?.() || 0);
      const p = Number(map.getPitch?.() || 0);
      if (![lng, lat, z, b, p].every((n) => Number.isFinite(n))) return "";
      const styleId =
        leafletBasemapMode === "streets"
          ? "mapbox/streets-v12"
          : leafletBasemapMode === "satellite"
            ? "mapbox/satellite-v9"
            : leafletBasemapMode === "base"
              ? "mapbox/light-v11"
              : "mapbox/satellite-streets-v12";
      const w = 1024;
      const h = 768;
      const overlay = overlayFromFeatures();
      const overlayPart = overlay ? `${overlay}/` : "";
      return `https://api.mapbox.com/styles/v1/${styleId}/static/${overlayPart}${lng.toFixed(6)},${lat.toFixed(
        6
      )},${z.toFixed(2)},${b.toFixed(0)},${p.toFixed(0)}/${w}x${h}?access_token=${encodeURIComponent(token)}`;
    } catch (_) {
      return "";
    }
  })();

  const calcForSpacing = (spacingM) => {
    let perimeterM = 0;
    let corners = 0;
    let uprights = 0;
    let sets4m = 0;
    let sets3m = 0;

    for (const f of feats) {
      const info = getFeatureLengthAndCorners(f);
      if (!info) continue;
      perimeterM += info.lengthM;
      corners += info.corners;
      const u = estimateUprightsForFeature(info.lengthM, spacingM, info.vertices, info.isClosedLoop);
      uprights += u;
      const bays = Math.max(0, info.isClosedLoop ? u : u - 1);
      if (spacingM === 3) {
        sets3m += bays;
      } else if (spacingM === 4) {
        const s = splitRailingSetsBySpacing(info.lengthM, 4);
        sets4m += s.sets4m;
        sets3m += s.sets3m;
      }
    }

    return {
      perimeterM,
      corners,
      uprights,
      sets4m,
      sets3m,
      uprightSpacingM: spacingM,
    };
  };

  const c3 = calcForSpacing(3);
  const c4 = calcForSpacing(4);

  const block = (c) => [
    `Uprights distance: ${c.uprightSpacingM} m`,
    `- Total length: ${Number(c.perimeterM || 0).toFixed(1)} m`,
    `- Total corners: ${c.corners ?? "-"}`,
    `- Total uprights: ${c.uprights ?? "-"}`,
    `- Total railing sets 4m: ${c.sets4m ?? "-"}`,
    `- Total railing sets 3m: ${c.sets3m ?? "-"}`,
  ].join("\n");

  return {
    address: address || "-",
    snapshotUrl: snapshotUrl || "-",
    uprights3m: block(c3),
    uprights4m: block(c4),
  };
}

function getContactModalForm() {
  const modal = document.getElementById("contactModal");
  if (!modal) return null;
  return modal.querySelector("form");
}

function setContactFieldValue(formEl, selector, value) {
  const el = formEl?.querySelector?.(selector);
  if (el) el.value = value || "";
}

function syncContactFenceFieldsIntoForm(formEl) {
  const form = formEl || getContactModalForm();
  if (!form) return;
  try {
    if (!getAllDrawFeatures().length) {
      setContactFieldValue(form, "#ContactForm-map-address", "");
      setContactFieldValue(form, "#ContactForm-map-snapshot", "");
      setContactFieldValue(form, "#ContactForm-uprights-3m", "");
      setContactFieldValue(form, "#ContactForm-uprights-4m", "");
      return;
    }
    // Do not mix old fencing requests. Always overwrite hidden fields with the current fence data.
    const data = buildContactFenceFields();
    setContactFieldValue(form, "#ContactForm-map-address", data.address);
    setContactFieldValue(form, "#ContactForm-map-snapshot", data.snapshotUrl);
    setContactFieldValue(form, "#ContactForm-uprights-3m", data.uprights3m);
    setContactFieldValue(form, "#ContactForm-uprights-4m", data.uprights4m);
  } catch (_) {
    setContactFieldValue(form, "#ContactForm-map-address", "");
    setContactFieldValue(form, "#ContactForm-map-snapshot", "");
    setContactFieldValue(form, "#ContactForm-uprights-3m", "");
    setContactFieldValue(form, "#ContactForm-uprights-4m", "");
  }
}

function setContactModalOpen(open) {
  const modal = document.getElementById("contactModal");
  if (!modal) return;
  if (open) modal.removeAttribute("hidden");
  else modal.setAttribute("hidden", "");
  if (open) {
    const status = document.getElementById("contactFormStatus");
    if (status) status.textContent = "";
    syncContactFenceFieldsIntoForm(getContactModalForm());
    // Shopify themes may render the form late; ensure submit handler is attached.
    try {
      const formEl = getContactModalForm();
      if (formEl && formEl.dataset.bound !== "1") {
        // bindUI's helper will attach on first call via this custom event
      }
    } catch (_) {
      /* ignore */
    }
  }
}

function autoSaveFenceSoon() {
  if (autoSaveFenceTimer) clearTimeout(autoSaveFenceTimer);
  autoSaveFenceTimer = setTimeout(() => {
    autoSaveFenceTimer = null;
    if (autoSaveInFlight) return;
    autoSaveInFlight = true;
    saveFence({ silent: true })
      .catch(() => {
        /* ignore (errors already handled in saveFence) */
      })
      .finally(() => {
        autoSaveInFlight = false;
      });
  }, 650);
}

function saveDraftFenceSoon() {
  if (draftSaveTimer) clearTimeout(draftSaveTimer);
  draftSaveTimer = setTimeout(() => {
    draftSaveTimer = null;
    try {
      const features = getAllDrawFeatures();
      const geojson =
        features.length === 0
          ? null
          : features.length === 1
            ? features[0]
            : { type: "FeatureCollection", features: [...features] };
      // `sectionName` is only meaningful for a single boundary.
      // For multi-section drafts, each feature has its own `properties.sectionName`.
      const singleSectionName = features.length === 1 ? (getSectionName?.() || "") : "";
      localStorage.setItem(DRAFT_FENCE_KEY, JSON.stringify({
        geojson,
        uprightSpacingM,
        sectionName: singleSectionName,
        savedAt: new Date().toISOString(),
      }));
    } catch (_) {
      /* ignore */
    }
  }, 250);
}

function loadDraftFence() {
  try {
    const raw = localStorage.getItem(DRAFT_FENCE_KEY);
    if (!raw) return;
    const data = JSON.parse(raw);
    const gj = data?.geojson;
    if (!gj) return;
    // IMPORTANT: do not force "started" on reload.
    // Users expect to pick a location (pin + address card + Start Project) each time they reload.
    // We can still restore the draft geometry for convenience.
    if (draw) addFeaturesToMapboxDraw(gj);
    else if (leafletMap) loadGeojsonOntoLeaflet(gj);
    applyLoadedFenceMeta(data);
    normalizeAutoSectionNamesAfterLoad();
    updateMeasurements();
  } catch (_) {
    /* ignore */
  }
}

function hasMap() {
  return !!(map || leafletMap);
}

function getEffectiveMapboxToken() {
  const cfg = NUXT_PUBLIC_CONFIG.vendors.mapbox?.key;
  if (cfg && typeof cfg === "string" && !cfg.startsWith("YOUR_") && cfg.startsWith("pk.")) {
    return cfg.trim();
  }
  try {
    const ls = localStorage.getItem("map_fencing_mapbox_token");
    if (ls && ls.startsWith("pk.")) return ls.trim();
  } catch (_) {
    /* ignore */
  }
  try {
    const q = new URLSearchParams(window.location.search).get("mapbox_token");
    if (q && q.startsWith("pk.")) return q.trim();
  } catch (_) {
    /* ignore */
  }
  return "";
}

function loadCss(href) {
  return new Promise((resolve, reject) => {
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = href;
    l.onload = () => resolve();
    l.onerror = () => reject(new Error(`Failed to load CSS: ${href}`));
    document.head.appendChild(l);
  });
}

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = src;
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.body.appendChild(s);
  });
}

async function loadLeafletDeps() {
  if (typeof L !== "undefined" && L.Draw && L.Control && L.Control.Draw) return;
  await loadCss("https://unpkg.com/leaflet@1.9.4/dist/leaflet.css");
  await loadCss("https://unpkg.com/leaflet-draw@1.0.4/dist/leaflet.draw.css");
  await loadCss("https://unpkg.com/leaflet-control-geocoder@2.4.0/dist/Control.Geocoder.css");
  await loadScript("https://unpkg.com/leaflet@1.9.4/dist/leaflet.js");
  await loadScript("https://unpkg.com/leaflet-draw@1.0.4/dist/leaflet.draw.js");
  await loadScript("https://unpkg.com/leaflet-control-geocoder@2.4.0/dist/Control.Geocoder.js");
}

/** Mapbox Draw may expose Points / vertex handles in getAll(); only list real fence geometries in the UI. */
function mapboxFenceRenderableFeature(f) {
  if (!f?.geometry) return false;
  const meta = f.properties?.meta;
  if (meta === "vertex" || meta === "midpoint") return false;
  const t = f.geometry.type;
  return t === "LineString" || t === "MultiLineString" || t === "Polygon" || t === "MultiPolygon";
}

/** Leave an active draw sketch before mutating features from the sidebar (avoids ghost "—" rows). */
function mapboxExitDrawModeIfNeeded() {
  if (mapProviderKind !== "mapbox" || !draw?.getMode || !draw.changeMode) return;
  const m = String(draw.getMode());
  if (!m.startsWith("draw_")) return;
  try {
    draw.changeMode("simple_select");
  } catch (_) {
    /* ignore */
  }
}

function getAllDrawFeatures() {
  if (draw?.getAll) {
    return (draw.getAll().features || []).filter((f) => f?.geometry && mapboxFenceRenderableFeature(f));
  }
  if (leafletDrawnItems) {
    const out = [];
    leafletDrawnItems.eachLayer((layer) => {
      const gj = layer.toGeoJSON?.();
      if (gj && gj.type === "Feature" && gj.geometry) out.push(gj);
    });
    return out;
  }
  return [];
}

/** Mapbox sketch geometry still being drawn — do not delete as "degenerate". */
function isMapboxActiveSketchFeature(feature, mode, allFeatures) {
  if (!feature || mode == null) return false;
  const ms = String(mode);
  if (!ms.startsWith("draw_")) return false;
  if (ms === "draw_line_string" && feature.geometry?.type === "LineString") {
    const lines = allFeatures.filter((x) => x.geometry?.type === "LineString");
    const last = lines[lines.length - 1];
    if (last && last.id === feature.id) {
      const n = normalizeLinePositions(feature.geometry.coordinates)?.length || 0;
      if (n < 2) return true;
    }
  }
  if (
    (ms === "draw_polygon" || ms === "draw_rectangle_drag") &&
    feature.geometry?.type === "Polygon"
  ) {
    const polys = allFeatures.filter((x) => x.geometry?.type === "Polygon");
    const last = polys[polys.length - 1];
    if (last && last.id === feature.id) {
      const ring = feature.geometry.coordinates?.[0];
      const pos = normalizeLinePositions(ring);
      const n = pos?.length || 0;
      if (n < 3) return true;
    }
  }
  return false;
}

/** Remove zero-length / invalid features so the sidebar never shows "—" ghost rows. */
function purgeDegenerateDrawFeatures() {
  if (typeof turf === "undefined") return;
  if (draw?.getAll) {
    const mode = draw.getMode?.();
    const feats = [...(draw.getAll().features || [])];
    for (const f of feats) {
      if (!f?.geometry) continue;
      if (isMapboxActiveSketchFeature(f, mode, feats)) continue;
      const info = getFeatureLengthAndCorners(f);
      if (!info || !Number.isFinite(info.lengthM) || info.lengthM <= 0) {
        try {
          if (f.id != null) draw.delete(f.id);
        } catch (_) {
          /* ignore */
        }
      }
    }
    return;
  }
  if (leafletDrawnItems) {
    const layers = leafletLayersInOrder();
    for (const layer of layers) {
      const gj = layer.toGeoJSON?.();
      if (!gj || gj.type !== "Feature" || !gj.geometry) {
        try {
          leafletDrawnItems.removeLayer(layer);
        } catch (_) {
          /* ignore */
        }
        continue;
      }
      const info = getFeatureLengthAndCorners(gj);
      if (!info || !Number.isFinite(info.lengthM) || info.lengthM <= 0) {
        try {
          leafletDrawnItems.removeLayer(layer);
        } catch (_) {
          /* ignore */
        }
      }
    }
  }
}

function getDrawCentroidLngLat() {
  const feats = getAllDrawFeatures();
  if (!feats.length || typeof turf === "undefined") return null;
  try {
    const fc = turf.featureCollection(feats);
    const c = turf.center(fc);
    const coords = c?.geometry?.coordinates;
    if (Array.isArray(coords) && coords.length >= 2 && Number.isFinite(coords[0]) && Number.isFinite(coords[1])) {
      return [coords[0], coords[1]];
    }
  } catch (_) {
    /* ignore */
  }
  return null;
}

async function reverseGeocodeLngLat(lng, lat, signal) {
  const token = getEffectiveMapboxToken();
  if (token) {
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(`${lng},${lat}`)}.json?access_token=${encodeURIComponent(token)}&limit=1`;
    const res = await fetch(url, { signal });
    if (res.ok) {
      const j = await res.json();
      const name = j.features?.[0]?.place_name;
      if (name && String(name).trim()) return String(name).trim();
    }
  }
  const nomUrl = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${encodeURIComponent(lat)}&lon=${encodeURIComponent(lng)}&zoom=18&addressdetails=0`;
  const res2 = await fetch(nomUrl, {
    signal,
    headers: { Accept: "application/json" },
  });
  if (!res2.ok) return "";
  const data = await res2.json();
  const dn = data.display_name;
  return dn && String(dn).trim() ? String(dn).trim() : "";
}

async function applyProjectPlaceFromDrawCentroid() {
  const feats = getAllDrawFeatures();
  if (!feats.length) return;
  const coords = getDrawCentroidLngLat();
  if (!coords) return;
  const [lng, lat] = coords;
  if (reversePlaceAbort) reversePlaceAbort.abort();
  reversePlaceAbort = new AbortController();
  const { signal } = reversePlaceAbort;
  try {
    const label = await reverseGeocodeLngLat(lng, lat, signal);
    if (label) setProjectPlaceFromSearch(label);
  } catch (e) {
    if (e.name !== "AbortError") {
      /* network / CORS — leave placeholder or prior search text */
    }
  }
}

function scheduleProjectPlaceReverseFromDraw() {
  if (reversePlaceTimer) clearTimeout(reversePlaceTimer);
  reversePlaceTimer = setTimeout(() => {
    reversePlaceTimer = null;
    void applyProjectPlaceFromDrawCentroid();
  }, 650);
}

function getPolygonFeaturesFromDraw() {
  return getAllDrawFeatures().filter((f) => {
    const t = f.geometry?.type;
    return t === "Polygon" || t === "MultiPolygon";
  });
}

function stopLeafletDraw() {
  if (activeLeafletDrawer) {
    try {
      activeLeafletDrawer.disable();
    } catch (_) {
      /* ignore */
    }
    activeLeafletDrawer = null;
  }
}

function startLeafletDrawMode(mode) {
  if (!leafletMap || !leafletDrawControlRef || typeof L === "undefined" || !L.Draw) return;
  if (!projectStarted) return;
  stopLeafletDraw();
  const o = leafletDrawControlRef.options.draw;
  if (mode === "line") activeLeafletDrawer = new L.Draw.Polyline(leafletMap, o.polyline);
  else if (mode === "polygon") activeLeafletDrawer = new L.Draw.Polygon(leafletMap, o.polygon);
  else if (mode === "rectangle") activeLeafletDrawer = new L.Draw.Rectangle(leafletMap, o.rectangle);
  if (activeLeafletDrawer) activeLeafletDrawer.enable();
}

function setDrawToolbarActiveMode(mode) {
  const m = normalizeDrawMode(mode);
  document.querySelectorAll(".draw-mode-btn").forEach((btn) => {
    btn.classList.toggle("is-active", btn.getAttribute("data-draw-mode") === m);
  });
}

function mapboxSetDrawMode(mode) {
  if (!draw?.changeMode) return;
  try {
    if (mode === "line") draw.changeMode("draw_line_string");
    else if (mode === "polygon") draw.changeMode("draw_polygon");
    else if (mode === "rectangle") {
      // Provided by rectangle-drag plugin
      draw.changeMode("draw_rectangle_drag");
    }
  } catch (e) {
    console.warn(e);
    try {
      const dict = STRINGS[appLocale] || STRINGS.en;
      setSaveStatus(`${dict.mapLoadError} Draw mode failed to activate.`);
    } catch (_) {
      /* ignore */
    }
  }
}

function ensureMapboxDrawArmed() {
  if (mapProviderKind !== "mapbox" || !projectStarted) return;
  if (!draw?.getMode || !draw?.changeMode) return;
  try {
    const dm = draw.getMode?.();
    if (!dm || !String(dm).startsWith("draw_")) {
      mapboxSetDrawMode(currentDrawMode || "line");
    }
  } catch (_) {
    /* ignore */
  }
}

function updateHelperRadiusButtonText() {
  const el = document.getElementById("helperRadiusLabel");
  if (!el) return;
  const other = helperRadiusM === 2 ? 4 : 2;
  el.textContent = `${helperRadiusM}m | ${other}m`;
  updateHelperProjector(null);
}

function refreshMapStageProviderClass() {
  const stage = document.querySelector(".map-stage");
  if (!stage) return;
  stage.classList.toggle("map-stage--mapbox", mapProviderKind === "mapbox");
  stage.classList.toggle("map-stage--leaflet", mapProviderKind === "leaflet");
}

function initDrawToolbar() {
  if (drawToolbarBound) return;
  const bar = document.getElementById("bottomDrawToolbar");
  if (!bar) return;
  drawToolbarBound = true;

  try {
    const s = localStorage.getItem(HELPER_RADIUS_STORAGE_KEY);
    if (s === "2" || s === "4") helperRadiusM = Number(s);
  } catch (_) {
    /* ignore */
  }
  updateHelperRadiusButtonText();
  ensureHelperProjector();

  bar.addEventListener("click", (ev) => {
    // Draw mode can be chosen before "Start Project" so it persists into primeDefaultDrawMode().
    const modeBtn = ev.target.closest(".draw-mode-btn");
    if (modeBtn) {
      const mode = modeBtn.getAttribute("data-draw-mode");
      if (mode && mapProviderKind) {
        setSavedDrawMode(mode);
        setDrawToolbarActiveMode(currentDrawMode);
        if (projectStarted) {
          if (mapProviderKind === "mapbox") mapboxSetDrawMode(mode);
          else startLeafletDrawMode(mode);
        }
      }
      return;
    }

    if (!projectStarted) {
      ev.preventDefault?.();
      return;
    }
    if (ev.target.closest("#helperRadiusBtn")) {
      helperRadiusM = helperRadiusM === 2 ? 4 : 2;
      try {
        localStorage.setItem(HELPER_RADIUS_STORAGE_KEY, String(helperRadiusM));
      } catch (_) {
        /* ignore */
      }
      updateHelperRadiusButtonText();
      updateMeasurements();
      updateHelperProjector(null);
      return;
    }
  });

  refreshMapStageProviderClass();
  // Reflect the last-used draw mode in the UI immediately.
  currentDrawMode = getSavedDrawMode();
  setDrawToolbarActiveMode(currentDrawMode);

  // If the project is already started, immediately arm the active mode on the active provider.
  // (Without this, Mapbox can end up with the UI selected but Draw not in a draw_* mode yet.)
  if (projectStarted) {
    try {
      if (mapProviderKind === "mapbox" && draw) mapboxSetDrawMode(currentDrawMode);
      else if (mapProviderKind === "leaflet") startLeafletDrawMode(currentDrawMode);
    } catch (_) {
      /* ignore */
    }
  }
}

function primeDefaultDrawMode() {
  if (!document.getElementById("bottomDrawToolbar")) return;
  currentDrawMode = getSavedDrawMode();
  setDrawToolbarActiveMode(currentDrawMode);
  if (!projectStarted) return;
  if (mapProviderKind === "mapbox" && draw) mapboxSetDrawMode(currentDrawMode);
  else if (mapProviderKind === "leaflet") startLeafletDrawMode(currentDrawMode);
}

function loadGeojsonOntoLeaflet(data, opts = {}) {
  if (!leafletMap || !leafletDrawnItems || !data) return;
  const skipArmDraw = !!opts.skipArmDraw;
  stopLeafletDraw();
  leafletDrawnItems.clearLayers();
  const normalized = normalizeGeojsonForDraw(data);
  if (!normalized) return;
  const addOne = (feat) => {
    const gjLayer = L.geoJSON(feat, {
      style: { color: FENCE_DRAW_LINE_COLOR, weight: FENCE_DRAW_LINE_WIDTH_PX, fillOpacity: FENCE_DRAW_FILL_OPACITY },
    });
    gjLayer.eachLayer((layer) => leafletDrawnItems.addLayer(layer));
  };
  if (normalized.type === "FeatureCollection" && Array.isArray(normalized.features)) {
    normalized.features.forEach(addOne);
  } else {
    addOne(normalized);
  }
  try {
    leafletDrawnItems.bringToFront();
  } catch (_) {
    /* ignore */
  }
  const b = leafletDrawnItems.getBounds?.();
  if (b?.isValid?.()) leafletMap.fitBounds(b.pad(0.08));
  if (projectStarted && !skipArmDraw) {
    setTimeout(() => {
      try {
        primeDefaultDrawMode();
      } catch (_) {
        /* ignore */
      }
    }, 0);
  }
}

function addFeaturesToMapboxDraw(data, opts = {}) {
  if (!draw) return;
  const modeAfter = opts.modeAfter === "simple_select" ? "simple_select" : "draw";
  const normalized = normalizeGeojsonForDraw(data);
  draw.deleteAll();
  if (!normalized) return;
  if (normalized.type === "FeatureCollection" && Array.isArray(normalized.features)) {
    normalized.features.forEach((f) => {
      if (f?.geometry) mapboxDrawAddCleanFeature(f.geometry, f.properties);
    });
  } else if (normalized.type === "Feature" && normalized.geometry) {
    mapboxDrawAddCleanFeature(normalized.geometry, normalized.properties);
  } else if (normalized.coordinates != null && normalized.type) {
    mapboxDrawAddCleanFeature(normalized, {});
  } else {
    return;
  }
  if (!projectStarted) return;
  setTimeout(() => {
    try {
      if (modeAfter === "simple_select") {
        draw.changeMode("simple_select");
      } else {
        primeDefaultDrawMode();
      }
    } catch (_) {
      /* ignore */
    }
  }, 0);
}

function cloneGeometryDeep(g) {
  try {
    return g ? JSON.parse(JSON.stringify(g)) : null;
  } catch (_) {
    return null;
  }
}

/** Mapbox Draw / saved GeoJSON sometimes nests coordinates one level too deep; flatten to [[lng,lat], …]. */
function normalizeLinePositions(coords) {
  if (!Array.isArray(coords) || coords.length === 0) return null;
  if (typeof coords[0]?.[0] === "number") {
    const a = coords[0];
    if (!Number.isFinite(a[0]) || !Number.isFinite(a[1])) return null;
    return coords;
  }
  const out = [];
  const walk = (node) => {
    if (!Array.isArray(node)) return;
    if (typeof node[0] === "number") {
      if (Number.isFinite(node[0]) && Number.isFinite(node[1])) out.push(node);
      return;
    }
    for (const x of node) walk(x);
  };
  walk(coords);
  return out.length ? out : null;
}

function polylineLengthMetersPositions(positions) {
  if (!positions || positions.length < 2 || typeof turf === "undefined" || typeof turf.distance !== "function") {
    return null;
  }
  let d = 0;
  for (let i = 1; i < positions.length; i++) {
    const a = positions[i - 1];
    const b = positions[i];
    if (!Array.isArray(a) || !Array.isArray(b)) return null;
    if (!Number.isFinite(a[0]) || !Number.isFinite(a[1]) || !Number.isFinite(b[0]) || !Number.isFinite(b[1])) {
      return null;
    }
    const seg = turf.distance(turf.point(a.slice(0, 2)), turf.point(b.slice(0, 2)), { units: "meters" });
    if (!Number.isFinite(seg)) return null;
    d += seg;
  }
  return d;
}

/** Reliable length (m) for LineString / MultiLineString segment coordinates. */
function lengthMForLineCoords(coords) {
  const pos = normalizeLinePositions(coords);
  if (!pos || pos.length < 2) return null;
  let len = null;
  if (typeof turf !== "undefined" && typeof turf.length === "function" && typeof turf.lineString === "function") {
    try {
      len = turf.length(turf.lineString(pos), { units: "meters" });
    } catch (_) {
      len = null;
    }
  }
  if (!Number.isFinite(len) || len < 0) len = polylineLengthMetersPositions(pos);
  return Number.isFinite(len) && len >= 0 ? len : null;
}

function closedRingLengthMeters(positions) {
  if (!positions || positions.length < 2) return null;
  const first = positions[0];
  const last = positions[positions.length - 1];
  const closed =
    positions.length >= 4 && first[0] === last[0] && first[1] === last[1];
  const path = closed ? positions.slice(0, -1) : positions;
  if (path.length < 2) return null;
  if (typeof turf === "undefined" || typeof turf.distance !== "function") return null;
  let d = 0;
  const n = path.length;
  for (let i = 0; i < n; i++) {
    const a = path[i];
    const b = path[(i + 1) % n];
    if (!Array.isArray(a) || !Array.isArray(b)) return null;
    d += turf.distance(turf.point(a.slice(0, 2)), turf.point(b.slice(0, 2)), { units: "meters" });
  }
  return Number.isFinite(d) && d >= 0 ? d : null;
}

function ringVertexCount(ring) {
  const pos = normalizeLinePositions(ring);
  if (!pos || pos.length < 2) return 0;
  let n = pos.length;
  const a = pos[0];
  const b = pos[n - 1];
  if (a[0] === b[0] && a[1] === b[1]) n -= 1;
  return Math.max(0, n);
}

/** Interior bend count for an open polyline (reference-style "corners", excluding the two ends). */
function openLineBendCount(coords) {
  const pos = normalizeLinePositions(coords);
  const n = pos?.length || 0;
  return Math.max(0, n - 2);
}

function cloneDrawFeatureProperties(props) {
  if (!props || typeof props !== "object") return {};
  try {
    return JSON.parse(JSON.stringify(props));
  } catch (_) {
    return { ...props };
  }
}

function mapboxDrawAddCleanFeature(geometry, properties) {
  if (!draw || !geometry) return;
  const geom = cloneGeometryDeep(geometry);
  if (!geom) return;
  draw.add({
    type: "Feature",
    properties: cloneDrawFeatureProperties(properties),
    geometry: geom,
  });
}

function sumFenceMetrics(features) {
  let perimeterM = 0;
  let areaM2 = 0;
  let corners = 0;
  let vertices = 0;

  for (const f of features) {
    const g = f?.geometry;
    if (!g) continue;

    if (g.type === "Polygon") {
      const ring = g.coordinates?.[0];
      const pos = normalizeLinePositions(ring);
      if (!pos || pos.length < 3) continue;
      let len = null;
      try {
        if (typeof turf.polygonToLine === "function" && typeof turf.length === "function") {
          len = turf.length(turf.polygonToLine(f), { units: "meters" });
        }
      } catch (_) {
        len = null;
      }
      if (!Number.isFinite(len) || len <= 0) len = closedRingLengthMeters(pos);
      if (!Number.isFinite(len) || len <= 0) continue;
      perimeterM += len;
      try {
        if (typeof turf.area === "function") areaM2 += turf.area(f);
      } catch (_) {
        /* ignore */
      }
      const v = ringVertexCount(ring);
      corners += v;
      vertices += v;
    } else if (g.type === "MultiPolygon") {
      for (const coords of g.coordinates || []) {
        const ring = coords?.[0];
        const pos = normalizeLinePositions(ring);
        if (!pos || pos.length < 3) continue;
        let len = null;
        try {
          if (
            typeof turf.polygon === "function" &&
            typeof turf.polygonToLine === "function" &&
            typeof turf.length === "function"
          ) {
            const polyFeat = turf.polygon(coords);
            len = turf.length(turf.polygonToLine(polyFeat), { units: "meters" });
            if (Number.isFinite(len) && len > 0) {
              try {
                if (typeof turf.area === "function") areaM2 += turf.area(polyFeat);
              } catch (_) {
                /* ignore */
              }
            }
          }
        } catch (_) {
          len = null;
        }
        if (!Number.isFinite(len) || len <= 0) len = closedRingLengthMeters(pos);
        if (!Number.isFinite(len) || len <= 0) continue;
        perimeterM += len;
        const v = ringVertexCount(ring);
        corners += v;
        vertices += v;
      }
    } else if (g.type === "LineString") {
      const coords = g.coordinates;
      const pos = normalizeLinePositions(coords);
      if (!pos || pos.length < 2) continue;
      const segLen = lengthMForLineCoords(coords);
      if (segLen == null || segLen <= 0) continue;
      perimeterM += segLen;
      corners += openLineBendCount(coords);
      vertices += pos.length;
    } else if (g.type === "MultiLineString") {
      for (const coords of g.coordinates || []) {
        const pos = normalizeLinePositions(coords);
        if (!pos || pos.length < 2) continue;
        const segLen = lengthMForLineCoords(coords);
        if (segLen == null || segLen <= 0) continue;
        perimeterM += segLen;
        corners += openLineBendCount(coords);
        vertices += pos.length;
      }
    }
  }

  return { perimeterM, areaM2, corners, vertices };
}

function applyI18n() {
  const dict = STRINGS[appLocale] || STRINGS.en;
  document.querySelectorAll("[data-i18n]").forEach((el) => {
    const key = el.getAttribute("data-i18n");
    if (!key) return;
    if (dict[key]) el.textContent = dict[key];
  });
  const homeBtn = document.getElementById("homeBtn");
  if (homeBtn && dict.homeBtn) homeBtn.setAttribute("aria-label", dict.homeBtn);
  document.querySelectorAll("[data-i18n-placeholder]").forEach((el) => {
    const key = el.getAttribute("data-i18n-placeholder");
    if (!key || !dict[key]) return;
    el.setAttribute("placeholder", dict[key]);
  });
  document.querySelectorAll("[data-i18n-aria]").forEach((el) => {
    const key = el.getAttribute("data-i18n-aria");
    if (!key || !dict[key]) return;
    el.setAttribute("aria-label", dict[key]);
  });
  updateHelperRadiusButtonText();
  refreshProjectPlaceAddress();
}

function refreshProjectPlaceAddress() {
  const el = document.getElementById("projectPlaceAddress");
  if (!el) return;
  const dict = STRINGS[appLocale] || STRINGS.en;
  const name = lastResolvedPlaceName.trim();
  if (name) {
    el.textContent = name;
    el.classList.remove("is-placeholder");
  } else {
    el.textContent = dict.projectAddressPlaceholder || "";
    el.classList.add("is-placeholder");
  }
}

function setProjectPlaceFromSearch(placeName) {
  lastResolvedPlaceName = placeName && String(placeName).trim() ? String(placeName).trim() : "";
  refreshProjectPlaceAddress();
  updateWindZoneFromAddressSoon();
}

function placeLabelFromHtml(html) {
  if (!html || typeof html !== "string") return "";
  const d = document.createElement("div");
  d.innerHTML = html;
  return (d.textContent || "").trim();
}

function extractGermanPostalCode(text) {
  const s = String(text || "");
  const m = s.match(/\b(\d{5})\b/);
  return m ? m[1] : "";
}

async function fetchWindZoneForPlz(plz) {
  const zip = String(plz || "").trim();
  if (!/^\d{5}$/.test(zip)) return "";
  // Source: DEHN windzone lookup (by zip). If CORS blocks this in-browser, we fall back to "open lookup" link.
  const url = `https://www.dehn.de/windzonen/?zip=${encodeURIComponent(zip)}`;
  const fetchText = async (u) => {
    const res = await fetch(u, { cache: "no-store" });
    if (!res.ok) return "";
    return await res.text();
  };

  let html = "";
  try {
    html = await fetchText(url);
  } catch (_) {
    html = "";
  }

  // CORS-friendly fallback: Jina AI proxy returns the HTML as text.
  if (!html) {
    try {
      html = await fetchText(`https://r.jina.ai/${url}`);
    } catch (_) {
      html = "";
    }
  }
  if (!html) return "";

  // Prefer a robust regex parse (DOM parsing can fail on proxied/rewritten HTML).
  const m1 = html.match(/Windzone\s*([1-4])/i);
  if (m1) return m1[1];
  const m2 = html.match(/\b([1-4])\b/);
  if (m2) return m2[1];
  return "";
}

function setWindZoneUi({ plz = "", zone = "", canOpen = false } = {}) {
  const valueEl = document.getElementById("windZoneValue");
  const btn = document.getElementById("windZoneOpenBtn");
  if (valueEl) valueEl.textContent = zone ? String(zone) : "—";
  if (btn) {
    btn.hidden = !canOpen;
    btn.disabled = !canOpen;
    const url = `https://www.dehn.de/windzonen/?zip=${encodeURIComponent(String(plz || "").trim())}`;
    btn.onclick = canOpen
      ? () => {
          try {
            window.open(url, "_blank", "noopener,noreferrer");
          } catch (_) {
            /* ignore */
          }
        }
      : null;
  }
}

function updateWindZoneFromAddressSoon() {
  if (windZoneTimer) clearTimeout(windZoneTimer);
  windZoneTimer = setTimeout(() => {
    windZoneTimer = null;
    void (async () => {
      const plz = extractGermanPostalCode(lastResolvedPlaceName);
      if (!plz) {
        setWindZoneUi({ zone: "", canOpen: false });
        return;
      }
      try {
        const zone = await fetchWindZoneForPlz(plz);
        if (zone) setWindZoneUi({ plz, zone: `Windzone ${zone}`, canOpen: true });
        else setWindZoneUi({ plz, zone: "—", canOpen: true });
      } catch (_) {
        // Likely CORS blocked; still provide the open-lookup link.
        setWindZoneUi({ plz, zone: "—", canOpen: true });
      }
    })();
  }, 400);
}

function placeLabelFromMapboxGeocodeEvent(ev) {
  let r = ev?.result;
  if ((!r || typeof r !== "object") && ev?.type === "Feature" && ev.geometry) {
    r = ev;
  }
  if (!r || typeof r !== "object") return "";
  if (typeof r.place_name === "string" && r.place_name.trim()) return r.place_name.trim();
  if (typeof r.text === "string" && r.text.trim()) return r.text.trim();
  const p = r.properties;
  if (p && typeof p === "object") {
    if (typeof p.place_name === "string" && p.place_name.trim()) return p.place_name.trim();
    if (typeof p.name === "string" && p.name.trim()) return p.name.trim();
    if (typeof p.full_address === "string" && p.full_address.trim()) return p.full_address.trim();
    if (typeof p.address === "string" && p.address.trim()) return p.address.trim();
  }
  return "";
}

function getLngLatFromGeocodeResult(evOrGeocode) {
  const r = evOrGeocode?.result || evOrGeocode;
  const c = r?.center || r?.geometry?.coordinates;
  if (Array.isArray(c) && c.length >= 2 && Number.isFinite(c[0]) && Number.isFinite(c[1])) return [c[0], c[1]];
  return null;
}

/** Mapbox Geocoder bbox as [west, south, east, north], when the result covers an area. */
function getBboxFromMapboxGeocodeResult(evOrGeocode) {
  const r = evOrGeocode?.result || evOrGeocode;
  const b = r?.bbox;
  if (Array.isArray(b) && b.length === 4 && b.every((x) => Number.isFinite(x))) {
    const [w, s, e, n] = b;
    if (e > w && n > s) return b;
  }
  return null;
}

function setProjectorToLngLat(lngLat) {
  if (!lngLat) return;
  // Ensure layers/listeners exist, then force an immediate projector update.
  try { ensureHelperProjector(); } catch (_) { /* ignore */ }
  updateHelperProjector(lngLat);
}

function showMapClickCard(addressText) {
  const card = document.getElementById("mapClickCard");
  const t = document.getElementById("mapClickAddressText");
  if (!card || !t) return;
  t.textContent = addressText || "";
  card.hidden = false;
}

function hideMapClickCard() {
  const card = document.getElementById("mapClickCard");
  if (card) card.hidden = true;
}

function showPickedLocationFromSearch(provider, lngLat, label, mapInstance) {
  if (!Array.isArray(lngLat) || lngLat.length < 2) return;
  lastClickedLngLat = lngLat;

  // Debug/status hint so we can verify this handler runs.
  try {
    setSaveStatus(`Picked (${provider}) • started:${projectStarted} • ${label || `${lngLat[1].toFixed?.(5)}, ${lngLat[0].toFixed?.(5)}`}`);
  } catch (_) {
    /* ignore */
  }

  if (!projectStarted) {
    showMapClickCard(label || "Selected location");
  } else {
    hideMapClickCard();
  }

  // Move projector immediately (even before Start Project).
  try {
    setProjectorToLngLat(lngLat);
  } catch (_) {
    /* ignore */
  }

  // Drop/refresh the pick marker before Start Project.
  if (projectStarted) {
    clearProjectPickMarker();
    return;
  }

  try {
    if (provider === "mapbox" && mapInstance && typeof mapboxgl !== "undefined") {
      if (!mapboxSearchMarker) {
        mapboxSearchMarker = new mapboxgl.Marker({ color: "#e53935" }).setLngLat(lngLat).addTo(mapInstance);
      } else {
        mapboxSearchMarker.setLngLat(lngLat);
      }
    } else if (provider === "leaflet" && leafletMap && typeof L !== "undefined") {
      const ll = L.latLng(lngLat[1], lngLat[0]);
      if (!leafletSearchMarker) {
        leafletSearchMarker = L.marker(ll, { interactive: false });
        leafletSearchMarker.addTo(leafletMap);
      } else {
        leafletSearchMarker.setLatLng(ll);
      }
    }
  } catch (_) {
    /* ignore */
  }
}

function clearProjectPickMarker() {
  try {
    if (leafletSearchMarker && leafletMap) {
      leafletMap.removeLayer(leafletSearchMarker);
    }
  } catch (_) {
    /* ignore */
  }
  leafletSearchMarker = null;

  try {
    mapboxSearchMarker?.remove?.();
  } catch (_) {
    /* ignore */
  }
  mapboxSearchMarker = null;
}

function bindStartProjectButton() {
  const btn = document.getElementById("startProjectBtn");
  if (!btn || btn.dataset.bound) return;
  btn.dataset.bound = "1";
  btn.addEventListener("click", () => {
    const addr = document.getElementById("mapClickAddressText")?.textContent?.trim?.() || "";
    if (addr) setProjectPlaceFromSearch(addr);
    hideMapClickCard();
    projectStarted = true;
    if (!lastClickedLngLat) return;

    // Zoom to the picked point first, then start the projector exactly there.
    // Some map engines won't emit moveend if center/zoom didn't actually change,
    // which previously required an extra click to "wake" the projector.
    const targetLngLat = lastClickedLngLat;

    let afterMoveRan = false;
    const afterMove = () => {
      if (afterMoveRan) return;
      afterMoveRan = true;
      setProjectorToLngLat(targetLngLat);
      // Re-run once shortly after in case libs finish loading late.
      setTimeout(() => setProjectorToLngLat(targetLngLat), 450);
      scheduleMapGridSync();
      // Start in default draw mode after the project is started.
      if (mapProviderKind === "mapbox" && draw) {
        primeDefaultDrawMode();
        ensureMapboxDrawArmed();
      }
      if (mapProviderKind === "leaflet" && leafletMap) primeDefaultDrawMode();
      // Remove the picked-location pin once the project has started.
      clearProjectPickMarker();
    };

    // Guaranteed fallback: run even if moveend never fires.
    setTimeout(afterMove, 700);

    try {
      if (mapProviderKind === "mapbox" && map?.flyTo) {
        try { ensureHelperProjector(); } catch (_) { /* ignore */ }
        map.once("moveend", afterMove);
        map.flyTo({ center: targetLngLat, zoom: Math.max(map.getZoom?.() || 0, MAP_DETAIL_ZOOM), essential: true });
        return;
      }
    } catch (_) {
      /* ignore */
    }

    try {
      if (mapProviderKind === "leaflet" && leafletMap?.setView) {
        try { ensureHelperProjector(); } catch (_) { /* ignore */ }
        leafletMap.once("moveend", afterMove);
        leafletMap.setView([targetLngLat[1], targetLngLat[0]], Math.max(leafletMap.getZoom?.() || 0, MAP_DETAIL_ZOOM), {
          animate: true,
        });
        return;
      }
    } catch (_) {
      /* ignore */
    }

    // Fallback: no move event available.
    afterMove();
  });
}

/** Mapbox Geocoder always mirrors the chosen place into the control input — sync from that as the source of truth. */
function wireMapboxGeocoderProjectAddress(mapInstance, geocoder) {
  const pickInput = () =>
    geocoder._inputEl ||
    mapInstance.getContainer().querySelector(".mapboxgl-ctrl-geocoder--input");

  const syncFromInput = () => {
    const input = pickInput();
    if (!input) return;
    const v = String(input.value || "").trim();
    if (v.length >= 3) {
      setProjectPlaceFromSearch(v);
    } else if (!v) {
      setProjectPlaceFromSearch("");
    }
  };

  const attachInputMirror = () => {
    const input = pickInput();
    if (!input || input.dataset.mapFenceAddrMirror) return;
    input.dataset.mapFenceAddrMirror = "1";
    input.setAttribute("autocomplete", "off");
    input.setAttribute("spellcheck", "false");
    input.addEventListener("change", syncFromInput);
  };

  geocoder.on("result", (evArg) => {
    const label = placeLabelFromMapboxGeocodeEvent(evArg);
    if (label) {
      setProjectPlaceFromSearch(label);
    }
    const lngLat = getLngLatFromGeocodeResult(evArg);
    showPickedLocationFromSearch("mapbox", lngLat, label, mapInstance);
    // Prefer fitting the result bbox (area) like the reference; otherwise zoom to the point.
    const bbox = getBboxFromMapboxGeocodeResult(evArg);
    if (bbox && mapInstance?.fitBounds) {
      try {
        mapInstance.fitBounds(
          [
            [bbox[0], bbox[1]],
            [bbox[2], bbox[3]],
          ],
          { padding: 48, maxZoom: MAP_DETAIL_ZOOM, duration: 1200, essential: true }
        );
      } catch (_) {
        if (lngLat && mapInstance?.flyTo) {
          try {
            mapInstance.flyTo({ center: lngLat, zoom: Math.max(mapInstance.getZoom?.() || 0, MAP_DETAIL_ZOOM), essential: true });
          } catch {
            /* ignore */
          }
        }
      }
    } else if (lngLat && mapInstance?.flyTo) {
      try {
        mapInstance.flyTo({ center: lngLat, zoom: Math.max(mapInstance.getZoom?.() || 0, MAP_DETAIL_ZOOM), essential: true });
      } catch (_) {
        /* ignore */
      }
    }
    // After the project is started, never keep a "pick" marker on the map.
    if (projectStarted) clearProjectPickMarker();
    syncFromInput();
    const again = () => syncFromInput();
    mapInstance.once("moveend", again);
    setTimeout(again, 100);
    setTimeout(again, 600);
  });

  geocoder.on("clear", () => {
    setTimeout(() => {
      const input = pickInput();
      if (input && !String(input.value || "").trim()) {
        setProjectPlaceFromSearch("");
      }
    }, 0);
  });

  attachInputMirror();
  mapInstance.once("load", () => {
    attachInputMirror();
    setTimeout(attachInputMirror, 50);
  });
  setTimeout(attachInputMirror, 0);
}

function placeLabelFromLeafletGeocode(g) {
  if (!g) return "";
  if (typeof g.name === "string" && g.name.trim()) return g.name.trim();
  const dn = g.properties?.display_name;
  if (typeof dn === "string" && dn.trim()) return dn.trim();
  if (typeof g.html === "string" && g.html.trim()) {
    const t = placeLabelFromHtml(g.html);
    if (t) return t;
  }
  return "";
}

function initLanguageSelect() {
  const select = document.getElementById("langSelect");
  const locales = NUXT_PUBLIC_CONFIG.vendors.i18n.locales || [];
  select.innerHTML = "";

  for (const loc of locales) {
    const opt = document.createElement("option");
    opt.value = loc.code;
    opt.textContent = loc.code;
    opt.title = loc.name;
    select.appendChild(opt);
  }

  select.value = appLocale;
  select.addEventListener("change", () => {
    appLocale = select.value;
    localStorage.setItem("map_fencing_locale", appLocale);
    applyI18n();
    syncMapLayerCheckboxesFromState();
    scheduleMapGridSync();
    updateMeasurements();
    if (firestore) {
      loadLatestFences().catch(() => renderFenceListPlaceholder());
    } else {
      renderFenceListPlaceholder();
    }
  });
}

function setSaveStatus(text) {
  const el = document.getElementById("saveStatus");
  if (el) el.textContent = text;
}

function splitRailingSets(perimeterM) {
  let p = Math.max(0, perimeterM);
  let sets4m = 0;
  while (p + 1e-6 >= 4) {
    sets4m += 1;
    p -= 4;
  }
  let sets3m = 0;
  if (p > 0.05) {
    sets3m = Math.ceil(p / 3);
  }
  return { sets4m, sets3m };
}

function estimateUprightCount(perimeterM, spacingM, cornerCount) {
  if (!Number.isFinite(perimeterM) || perimeterM <= 0 || !spacingM) return 0;
  return estimateUprightsForFeature(perimeterM, spacingM, cornerCount, false);
}

function splitRailingSetsBySpacing(lengthM, spacingM) {
  const len = Math.max(0, lengthM);
  if (!Number.isFinite(len) || len <= 0) return { sets4m: 0, sets3m: 0 };

  // Reference behavior: 3m spacing -> only 3m rails.
  if (spacingM === 3) return { sets4m: 0, sets3m: Math.ceil(len / 3) };

  // Reference behavior: 4m spacing prefers 4m rails, but leftover can require 3m rails too.
  if (spacingM === 4) {
    let remaining = len;
    const sets4m = Math.floor((remaining + 1e-6) / 4);
    remaining -= sets4m * 4;
    const sets3m = remaining > 0.05 ? Math.ceil(remaining / 3) : 0;
    return { sets4m, sets3m };
  }

  // Fallback: keep prior greedy split for other values.
  return splitRailingSets(len);
}

function estimateUprightsForFeature(lengthM, spacingM, vertexCount, isClosedLoop) {
  if (!Number.isFinite(lengthM) || lengthM <= 0 || !spacingM) return 0;

  const along = Math.ceil(lengthM / spacingM);
  const v = Math.max(0, vertexCount || 0);

  if (isClosedLoop) {
    // Closed boundary: uprights follow perimeter spacing only (Protector-style).
    return along;
  }

  // Open run: same as reference calculators — both ends get a post (+2).
  const raw = along + 2;
  return Math.max(raw, v);
}

function getFeatureLengthAndCorners(feature) {
  const g = feature?.geometry;
  if (!g || typeof turf === "undefined") return null;

  if (g.type === "LineString") {
    const coords = g.coordinates || [];
    const pos = normalizeLinePositions(coords);
    if (!pos || pos.length < 2) return null;
    const lengthM = lengthMForLineCoords(coords);
    if (lengthM == null || lengthM <= 0) return null;
    const vertices = pos.length;
    const corners = openLineBendCount(coords);
    return { lengthM, corners, vertices, isClosedLoop: false };
  }
  if (g.type === "MultiLineString") {
    let lengthM = 0;
    let corners = 0;
    let vertices = 0;
    for (const coords of g.coordinates || []) {
      const pos = normalizeLinePositions(coords);
      if (!pos || pos.length < 2) continue;
      const seg = lengthMForLineCoords(coords);
      if (seg == null || seg <= 0) continue;
      lengthM += seg;
      corners += openLineBendCount(coords);
      vertices += pos.length;
    }
    if (vertices < 2 || lengthM <= 0) return null;
    return { lengthM, corners, vertices, isClosedLoop: false };
  }
  if (g.type === "Polygon") {
    const ring = g.coordinates?.[0] || [];
    const pos = normalizeLinePositions(ring);
    if (!pos || pos.length < 3) return null;
    let lengthM = null;
    try {
      if (typeof turf.polygonToLine === "function" && typeof turf.length === "function") {
        lengthM = turf.length(turf.polygonToLine(feature), { units: "meters" });
      }
    } catch (_) {
      lengthM = null;
    }
    if (!Number.isFinite(lengthM) || lengthM <= 0) lengthM = closedRingLengthMeters(pos);
    if (lengthM == null || lengthM <= 0) return null;
    const vertices = ringVertexCount(ring);
    return { lengthM, corners: vertices, vertices, isClosedLoop: true };
  }
  if (g.type === "MultiPolygon") {
    let lengthM = 0;
    let corners = 0;
    let vertices = 0;
    for (const coords of g.coordinates || []) {
      const ring = coords?.[0] || [];
      const pos = normalizeLinePositions(ring);
      if (!pos || pos.length < 3) continue;
      let seg = null;
      try {
        if (
          typeof turf.polygon === "function" &&
          typeof turf.polygonToLine === "function" &&
          typeof turf.length === "function"
        ) {
          const polyFeat = turf.polygon(coords);
          seg = turf.length(turf.polygonToLine(polyFeat), { units: "meters" });
        }
      } catch (_) {
        seg = null;
      }
      if (!Number.isFinite(seg) || seg <= 0) seg = closedRingLengthMeters(pos);
      if (seg == null || seg <= 0) continue;
      lengthM += seg;
      const v = ringVertexCount(ring);
      corners += v;
      vertices += v;
    }
    if (vertices < 3 || lengthM <= 0) return null;
    return { lengthM, corners, vertices, isClosedLoop: true };
  }
  return null;
}

function getSectionName() {
  const raw = getRawSectionNameInput();
  if (raw) return raw;
  const dict = STRINGS[appLocale] || STRINGS.en;
  return dict.sectionNamePlaceholder || "Section 01";
}

function getRawSectionNameInput() {
  const f = getAllDrawFeatures()[0];
  const v = f?.properties?.sectionName;
  return v && String(v).trim() ? String(v).trim() : "";
}

function nextAutoSectionName() {
  let n = 1;
  try {
    const raw = localStorage.getItem(SECTION_COUNTER_KEY);
    const parsed = raw ? Number(raw) : NaN;
    if (Number.isFinite(parsed) && parsed >= 1) n = parsed;
  } catch (_) {
    /* ignore */
  }
  const name = `Section ${String(n).padStart(2, "0")}`;
  try {
    localStorage.setItem(SECTION_COUNTER_KEY, String(n + 1));
  } catch (_) {
    /* ignore */
  }
  return name;
}

function setSectionNameCounter(nextN) {
  const n = Number(nextN);
  if (!Number.isFinite(n) || n < 1) return;
  try {
    localStorage.setItem(SECTION_COUNTER_KEY, String(Math.floor(n)));
  } catch (_) {
    /* ignore */
  }
}

function autoSectionNameSuffix(name) {
  const m = String(name || "").trim().match(/^(section|sectie|abschnitt)\s+(\d+)\s*$/i);
  if (!m) return null;
  const n = Number(m[2]);
  return Number.isFinite(n) && n >= 1 ? n : null;
}

/**
 * Keep auto section names stable after reload/load:
 * - Restored auto sections should display as Section 01..N (not continue 04..)
 * - Counter should be set so future auto names continue after N.
 */
function normalizeAutoSectionNamesAfterLoad() {
  const featsSorted = sortDrawFeaturesForDisplay(getAllDrawFeatures());
  if (!featsSorted.length) {
    resetSectionNameCounterToFirst();
    return;
  }

  const shouldAutoName = featsSorted.map((f) => {
    const raw = f?.properties?.sectionName;
    const name = raw == null ? "" : String(raw).trim();
    if (!name) return true;
    return autoSectionNameSuffix(name) != null;
  });

  if (!shouldAutoName.some(Boolean)) {
    resetSectionNameCounterToFirst();
    return;
  }

  let next = 1;
  const nextName = () => `Section ${String(next++).padStart(2, "0")}`;

  if (draw) {
    featsSorted.forEach((f, i) => {
      if (!shouldAutoName[i]) return;
      if (f?.id == null) return;
      updateMapboxFeatureProperties(f.id, { sectionName: nextName() });
    });
  } else if (leafletDrawnItems) {
    const layers = leafletLayersInOrder();
    let leafNext = 1;
    for (let i = 0; i < layers.length; i++) {
      const gj = layers[i]?.toGeoJSON?.();
      const raw = gj?.properties?.sectionName;
      const name = raw == null ? "" : String(raw).trim();
      const isAuto = !name || autoSectionNameSuffix(name) != null;
      if (!isAuto) continue;
      const nm = `Section ${String(leafNext++).padStart(2, "0")}`;
      updateLeafletLayerGeojsonAtIndex(i, { sectionName: nm });
    }
    next = leafNext;
  }

  setSectionNameCounter(next);
}

/** After all sections are removed, the next drawn section should be Section 01 again. */
function resetSectionNameCounterToFirst() {
  try {
    localStorage.setItem(SECTION_COUNTER_KEY, "1");
  } catch (_) {
    /* ignore */
  }
}

function getCurrentCalculations() {
  const feats = getAllDrawFeatures();
  if (!feats.length || typeof turf === "undefined") return null;
  const { perimeterM, areaM2, corners, vertices } = sumFenceMetrics(feats);
  if (perimeterM <= 0) return null;

  // Reference behavior (matches protector demo):
  // - Upright spacing affects uprights count
  // - Rail set length is tied to the chosen spacing (3m -> 3m sets, 4m -> 4m sets)
  // - Rail set count is based on bays between uprights (open run: uprights-1, closed loop: uprights)
  let sets4m = 0;
  let sets3m = 0;
  let uprights = 0;
  for (const f of feats) {
    const info = getFeatureLengthAndCorners(f);
    if (!info) continue;
    const spacingM = getSegmentUprightSpacingM(f);
    const u = estimateUprightsForFeature(info.lengthM, spacingM, info.vertices, info.isClosedLoop);
    uprights += u;

    const bays = Math.max(0, info.isClosedLoop ? u : u - 1);
    if (spacingM === 3) {
      sets3m += bays;
    } else if (spacingM === 4) {
      const s = splitRailingSetsBySpacing(info.lengthM, 4);
      sets4m += s.sets4m;
      sets3m += s.sets3m;
    } else {
      const s = splitRailingSets(info.lengthM);
      sets4m += s.sets4m;
      sets3m += s.sets3m;
    }
  }

  // Fallback if something went wrong.
  if (!Number.isFinite(uprights) || uprights <= 0) {
    uprights = estimateUprightCount(perimeterM, uprightSpacingM, vertices);
  }

  return {
    perimeterM,
    areaM2,
    corners,
    uprights,
    sets4m,
    sets3m,
    uprightSpacingM,
    helperRadiusM,
  };
}

function updateActiveDrawingPanelVisibility(showPanel) {
  const panel = document.getElementById("activeDrawingPanel");
  const help = document.getElementById("noDataHelp");
  if (!panel) return;
  if (!showPanel) {
    panel.hidden = true;
    if (help) help.hidden = !helpOverlayPinned ? false : false;
    return;
  }
  panel.hidden = false;
  if (help) help.hidden = !helpOverlayPinned;
}

function updateMeasurements() {
  if ((!draw && !leafletDrawnItems) || typeof turf === "undefined") {
    updateActiveDrawingPanelVisibility(false);
    renderDrawSegmentsList();
    updateSendRequestButtonVisibility();
    try {
      refreshFenceListUI();
    } catch (_) {
      /* ignore */
    }
    try {
      clearSegmentNameLabelMarkers();
    } catch (_) {
      /* ignore */
    }
    return;
  }

  try {
    purgeDegenerateDrawFeatures();
  } catch (_) {
    /* ignore */
  }

  try {
    ensureMapboxDrawSpacingOnFeatures();
  } catch (_) {
    /* ignore */
  }

  const feats = getAllDrawFeatures();
  if (feats.length === 0) {
    resetSectionNameCounterToFirst();
    document.body.classList.remove("has-drawing");
    updateActiveDrawingPanelVisibility(false);
    renderDrawSegmentsList();
    updateSendRequestButtonVisibility();
    hideLiveDrawLengthMarker();
    hideLiveLeafletLengthMarker();
    saveDraftFenceSoon();
    try {
      refreshFenceListUI();
    } catch (_) {
      /* ignore */
    }
    try {
      clearSegmentNameLabelMarkers();
    } catch (_) {
      /* ignore */
    }
    return;
  }

  document.body.classList.add("has-drawing");
  updateActiveDrawingPanelVisibility(true);
  renderDrawSegmentsList();
  updateSendRequestButtonVisibility();
  scheduleProjectPlaceReverseFromDraw();
  saveDraftFenceSoon();
  try {
    refreshFenceListUI();
  } catch (_) {
    /* ignore */
  }
  scheduleSegmentLabelRefresh();
    
  // Zeige Quote-Button wenn mindestens 1 Segment gezeichnet
  const quoteBtn = document.getElementById("requestQuoteBtn");
  if (quoteBtn) {
    quoteBtn.hidden = (getAllDrawFeatures ? getAllDrawFeatures() : []).length === 0;
  }
}

function formatFenceLengthCompact(perimeterM) {
  if (perimeterM == null || !Number.isFinite(Number(perimeterM))) return "—";
  const n = Number(perimeterM);
  const r = Math.round(n * 10) / 10;
  const s = Number.isInteger(r) ? String(Math.round(r)) : r.toFixed(1);
  return `${s}m`;
}

function renderFenceListPlaceholder(text) {
  const list = document.getElementById("fenceList");
  if (!list) return;
  const dict = STRINGS[appLocale] || STRINGS.en;
  list.innerHTML = `<div class="fence-list-empty">${escapeHtml(
    text || dict.fencesEmpty
  )}</div>`;
}

async function initFirebase() {
  const fb = NUXT_PUBLIC_CONFIG.vendors.firebase;
  if (!fb || !fb.apiKey || fb.apiKey.startsWith("YOUR_")) {
    firestore = null;
    return;
  }

  try {
    if (!firebase.apps?.length) {
      firebase.initializeApp(fb);
    }
    firestore = firebase.firestore();
  } catch (err) {
    console.error(err);
    firestore = null;
  }
}

function readLocalFences() {
  try {
    const raw = localStorage.getItem(LOCAL_FENCES_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

function writeLocalFences(items) {
  try {
    localStorage.setItem(LOCAL_FENCES_KEY, JSON.stringify(items.slice(0, 25)));
  } catch (e) {
    console.warn(e);
  }
}

function initUprightSpacingControls() {
  try {
    const saved = localStorage.getItem(SPACING_STORAGE_KEY);
    if (saved === "3" || saved === "4") uprightSpacingM = Number(saved);
  } catch (_) {
    /* ignore */
  }

  document.querySelectorAll('input[name="uprightSpacing"]').forEach((r) => {
    r.checked = Number(r.value) === uprightSpacingM;
    r.addEventListener("change", () => {
      uprightSpacingM = Number(r.value);
      try {
        localStorage.setItem(SPACING_STORAGE_KEY, String(uprightSpacingM));
      } catch (_) {
        /* ignore */
      }
      updateMeasurements();
    });
  });
  
// Ständer-Typ Change Handler
document.getElementById("uprightTypeSelect")?.addEventListener("change", (e) => {
  uprightType = e.target.value;
  console.log("📌 Upright Type changed to:", uprightType);
  
  // Automatisch den richtigen Spacing setzen
  const typeSpacing = {
    "standard": 4,
    "corner": 3,
    "edge": 5
  };
  uprightSpacingM = typeSpacing[uprightType] || 4;
  
  // UI aktualisieren - Radio-Buttons checken
  document.querySelectorAll('input[name="uprightSpacing"]').forEach((r) => {
    r.checked = Number(r.value) === uprightSpacingM;
  });
  
  updateMeasurements();
  saveDraftFenceSoon();
});
}

let mapContainerResizeObserver = null;

/** Mapbox + Leaflet need correct container pixel size or clicks/lines misalign (not a CRS bug). */
function syncMapPixelGrid() {
  try {
    map?.resize?.();
  } catch (_) {
    /* ignore */
  }
  try {
    leafletMap?.invalidateSize?.({ animate: false });
  } catch (_) {
    /* ignore */
  }
}

function scheduleMapGridSync() {
  syncMapPixelGrid();
  requestAnimationFrame(() => syncMapPixelGrid());
  setTimeout(() => syncMapPixelGrid(), 100);
  setTimeout(() => syncMapPixelGrid(), 300);
  setTimeout(() => syncMapPixelGrid(), 600);
}

function observeMapContainerResize() {
  const el = document.getElementById("map");
  if (!el || typeof ResizeObserver === "undefined") return;
  if (mapContainerResizeObserver) {
    mapContainerResizeObserver.disconnect();
    mapContainerResizeObserver = null;
  }
  let debounce = null;
  mapContainerResizeObserver = new ResizeObserver(() => {
    if (debounce) clearTimeout(debounce);
    debounce = setTimeout(() => {
      debounce = null;
      syncMapPixelGrid();
    }, 40);
  });
  mapContainerResizeObserver.observe(el);
}

function bindMapResize() {
  window.addEventListener("resize", () => syncMapPixelGrid());
  const runLoadSync = () => scheduleMapGridSync();
  if (document.readyState === "complete") {
    setTimeout(runLoadSync, 0);
  } else {
    window.addEventListener("load", runLoadSync);
  }
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") syncMapPixelGrid();
  });
  try {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => syncMapPixelGrid());
    }
  } catch (_) {
    /* ignore */
  }
}

function rebuildLeafletBaseStack() {
  if (!leafletMap) return;
  if (leafletOrthoLayer) {
    leafletMap.removeLayer(leafletOrthoLayer);
    leafletOrthoLayer = null;
  }
  if (leafletStreetOverlay) {
    leafletMap.removeLayer(leafletStreetOverlay);
    leafletStreetOverlay = null;
  }
  if (leafletBaseLayer) {
    leafletMap.removeLayer(leafletBaseLayer);
    leafletBaseLayer = null;
  }

  const u = MAP_LAYER_URLS.leaflet;
  const mode = leafletBasemapMode;

  if (mode === "base") {
    leafletBaseLayer = L.tileLayer(u.baseLight, {
      maxZoom: 20,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> © CARTO',
      subdomains: "abcd",
    }).addTo(leafletMap);
  } else if (mode === "streets") {
    leafletBaseLayer = L.tileLayer(u.streets, {
      maxZoom: 19,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(leafletMap);
  } else if (mode === "satellite") {
    leafletBaseLayer = L.tileLayer(u.satellite, {
      maxZoom: 19,
      attribution: "Tiles © Esri",
    }).addTo(leafletMap);
  } else if (mode === "satelliteStreets") {
    leafletBaseLayer = L.tileLayer(u.satellite, {
      maxZoom: 19,
      attribution: "Tiles © Esri",
    }).addTo(leafletMap);
    leafletStreetOverlay = L.tileLayer(u.streets, {
      maxZoom: 19,
      opacity: u.satelliteStreetsOpacity,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(leafletMap);
  } else {
    leafletBasemapMode = "satelliteStreets";
    leafletBaseLayer = L.tileLayer(u.satellite, {
      maxZoom: 19,
      attribution: "Tiles © Esri",
    }).addTo(leafletMap);
    leafletStreetOverlay = L.tileLayer(u.streets, {
      maxZoom: 19,
      opacity: u.satelliteStreetsOpacity,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(leafletMap);
  }

  if (activeNlOrthoYear) {
    const tpl = MAP_LAYER_URLS.nlOrtho[activeNlOrthoYear];
    if (tpl) {
      leafletOrthoLayer = L.tileLayer(tpl, {
        maxZoom: 20,
        opacity: 0.9,
        attribution: "Ortho overlay",
      }).addTo(leafletMap);
    }
  }
}

function applyLeafletBasemap(mode) {
  leafletBasemapMode = mode;
  rebuildLeafletBaseStack();
}

function syncLeafletOrthoOnly() {
  if (!leafletMap) return;
  if (leafletOrthoLayer) {
    leafletMap.removeLayer(leafletOrthoLayer);
    leafletOrthoLayer = null;
  }
  if (!activeNlOrthoYear) return;
  const tpl = MAP_LAYER_URLS.nlOrtho[activeNlOrthoYear];
  if (!tpl) return;
  leafletOrthoLayer = L.tileLayer(tpl, {
    maxZoom: 20,
    opacity: 0.9,
    attribution: "Ortho overlay",
  }).addTo(leafletMap);
}

function removeMapboxOrthoLayer() {
  if (!map?.getStyle) return;
  try {
    if (map.getLayer(MAPBOX_ORTHO_LAYER_ID)) map.removeLayer(MAPBOX_ORTHO_LAYER_ID);
    if (map.getSource(MAPBOX_ORTHO_SOURCE_ID)) map.removeSource(MAPBOX_ORTHO_SOURCE_ID);
  } catch (_) {
    /* ignore */
  }
}

function addMapboxOrthoLayer(year) {
  if (!map || !year) return;
  const tpl = MAP_LAYER_URLS.nlOrtho[year];
  if (!tpl || !map.addSource) return;
  removeMapboxOrthoLayer();
  try {
    map.addSource(MAPBOX_ORTHO_SOURCE_ID, {
      type: "raster",
      tiles: [tpl],
      tileSize: 256,
      attribution: "Ortho NL",
    });
    map.addLayer({
      id: MAPBOX_ORTHO_LAYER_ID,
      type: "raster",
      source: MAPBOX_ORTHO_SOURCE_ID,
      paint: { "raster-opacity": 0.88 },
    });
  } catch (err) {
    console.warn("Ortho layer:", err);
  }
}

function mapboxSnapshotDraw() {
  if (!draw?.getAll) return null;
  try {
    return JSON.parse(JSON.stringify(draw.getAll()));
  } catch {
    return null;
  }
}

function mapboxRestoreDraw(fc) {
  if (!draw || !fc?.features?.length) return;
  try {
    draw.deleteAll();
    fc.features.forEach((f) => {
      if (f?.geometry) mapboxDrawAddCleanFeature(f.geometry, f.properties);
    });
  } catch (err) {
    console.warn(err);
  }
}

function mapboxApplyBasemap(mode) {
  if (!map || !MAP_LAYER_URLS.mapbox[mode]) return;
  leafletBasemapMode = mode;
  const snap = mapboxSnapshotDraw();
  const orthoYear = activeNlOrthoYear;
  // Changing styles nukes custom sources/layers; force rebind of helper projector after setStyle.
  helperProjectorBound.mapbox = false;
  mapboxProjectorReady = false;
  map.setStyle(MAP_LAYER_URLS.mapbox[mode]);
  map.once("idle", () => {
    mapboxRestoreDraw(snap);
    if (orthoYear) addMapboxOrthoLayer(orthoYear);
    ensureHelperProjector();
    ensureMapboxDrawArmed();
    try {
      enforceMapboxDrawLinePaint();
    } catch (_) {
      /* ignore */
    }
    updateMeasurements();
  });
}

/** Mapbox Draw uses dashed "active" strokes by default; force solid green + min width on all draw line layers. */
function enforceMapboxDrawLinePaint() {
  if (!map || typeof map.getStyle !== "function") return;
  const layers = map.getStyle()?.layers;
  if (!Array.isArray(layers)) return;
  for (const layer of layers) {
    if (!layer || layer.type !== "line") continue;
    const id = String(layer.id || "");
    if (!id.includes("gl-draw")) continue;
    try {
      map.removePaintProperty(id, "line-dasharray");
    } catch (_) {
      /* no dash set */
    }
    try {
      map.setPaintProperty(id, "line-color", FENCE_DRAW_LINE_COLOR);
      // Always set literal width (Draw may keep zoom expressions or defaults that read thinner than expected).
      map.setPaintProperty(id, "line-width", FENCE_DRAW_LINE_WIDTH_PX);
    } catch (_) {
      /* ignore */
    }
  }
}

function getCheckedGlobalBasemap() {
  const el = document.querySelector('input[data-layer-group="global"]:checked');
  return el?.getAttribute("data-basemap") || "satelliteStreets";
}

function initMapLayerControls() {
  if (mapLayersBound) return;
  const panel = document.getElementById("mapLayersPanel");
  if (!panel) return;
  mapLayersBound = true;

  // Toggle button (like the reference site): button shows/hides the card.
  const toggleBtn = document.getElementById("mapLayersToggleBtn");
  const card = document.getElementById("mapLayersCard");
  const setOpen = (open) => {
    if (!toggleBtn || !card) return;
    card.hidden = !open;
    toggleBtn.setAttribute("aria-expanded", open ? "true" : "false");
  };
  if (toggleBtn && card) {
    setOpen(false);
    toggleBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      setOpen(card.hidden);
    });
    // Close when clicking outside.
    document.addEventListener("click", (e) => {
      if (card.hidden) return;
      const t = e.target;
      if (!(t instanceof Element)) return;
      if (t.closest("#mapLayersPanel")) return;
      setOpen(false);
    });
    // Close on Escape.
    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;
      if (card.hidden) return;
      setOpen(false);
    });
  }

  panel.addEventListener("change", (ev) => {
    const t = ev.target;
    if (!(t instanceof HTMLInputElement) || t.type !== "checkbox") return;

    const group = t.getAttribute("data-layer-group");
    if (group === "global") {
      if (!mapProviderKind) return;
      if (!t.checked) {
        t.checked = true;
        return;
      }
      panel.querySelectorAll('input[data-layer-group="global"]').forEach((cb) => {
        if (cb !== t) cb.checked = false;
      });
      const mode = t.getAttribute("data-basemap");
      leafletBasemapMode = mode || "satelliteStreets";
      if (mapProviderKind === "mapbox") mapboxApplyBasemap(leafletBasemapMode);
      else applyLeafletBasemap(leafletBasemapMode);
      return;
    }

    if (group === "nl") {
      if (!mapProviderKind) return;
      if (t.checked) {
        panel.querySelectorAll('input[data-layer-group="nl"]').forEach((cb) => {
          if (cb !== t) cb.checked = false;
        });
        activeNlOrthoYear = t.getAttribute("data-year");
      } else {
        activeNlOrthoYear = null;
      }
      if (mapProviderKind === "leaflet") syncLeafletOrthoOnly();
      else if (mapProviderKind === "mapbox" && map) {
        const applyOrtho = () => {
          removeMapboxOrthoLayer();
          if (activeNlOrthoYear) addMapboxOrthoLayer(activeNlOrthoYear);
        };
        if (map.isStyleLoaded?.()) applyOrtho();
        else map.once("idle", applyOrtho);
      }
    }
  });
}

function syncMapLayerCheckboxesFromState() {
  const panel = document.getElementById("mapLayersPanel");
  if (!panel) return;
  const basemap = leafletBasemapMode || getCheckedGlobalBasemap();
  panel.querySelectorAll('input[data-layer-group="global"]').forEach((cb) => {
    cb.checked = cb.getAttribute("data-basemap") === basemap;
  });
  panel.querySelectorAll('input[data-layer-group="nl"]').forEach((cb) => {
    cb.checked = cb.getAttribute("data-year") === activeNlOrthoYear;
  });
}

function initLeafletMap() {
  const dict = STRINGS[appLocale] || STRINGS.en;
  const el = document.getElementById("map");
  if (!el) return;

  mapProviderKind = "leaflet";
  leafletBasemapMode = getCheckedGlobalBasemap();

  leafletMap = L.map(el, {
    zoomControl: true,
    attributionControl: true,
    crs: L.CRS.EPSG3857,
    worldCopyJump: false,
  }).setView([HOME_VIEW.center[1], HOME_VIEW.center[0]], HOME_VIEW.zoom);

  rebuildLeafletBaseStack();
  bindKeyboardShortcuts();
  bindLeafletAltClickRemove();
  bindLeafletCloseLoopAssist();
  bindStartProjectButton();
  bindHomeButton();
  hideMapClickCard();

  leafletMap.on("click", (e) => {
    try {
      const oe = e?.originalEvent;
      // Ignore clicks on UI controls.
      if (
        oe?.target &&
        (oe.target.closest?.(".calc-panel") ||
          oe.target.closest?.(".leaflet-control") ||
          oe.target.closest?.(".bottom-toolbar") ||
          oe.target.closest?.(".map-layers-wrap"))
      ) {
        return;
      }
      if (!e?.latlng) return;
      lastClickedLngLat = [e.latlng.lng, e.latlng.lat];

      // Only show the picked-location pin BEFORE starting the project.
      if (!projectStarted) {
        if (!leafletSearchMarker) {
          leafletSearchMarker = L.marker(e.latlng, { interactive: false });
          leafletSearchMarker.addTo(leafletMap);
        } else {
          leafletSearchMarker.setLatLng(e.latlng);
        }
      } else {
        clearProjectPickMarker();
      }

      if (projectStarted) {
        // Don't run projector / side effects while editing or deleting vertices (breaks drag).
        if (document.body.classList.contains("leaflet-is-editing")) {
          return;
        }
        // While Leaflet.draw is active, still move the helper rings to each click (vertex),
        // but skip the heavier projector path that used to fight draw hit-testing.
        if (mapProviderKind === "leaflet" && activeLeafletDrawer) {
          try {
            ensureHelperProjector();
            updateHelperProjector([e.latlng.lng, e.latlng.lat]);
          } catch (_) {
            /* ignore */
          }
          hideMapClickCard();
          return;
        }
        setProjectorToLngLat(lastClickedLngLat);
        hideMapClickCard();
        return;
      }

      // Before Start Project: do not run projector/drawing yet, only show the card + pin.
      updateHelperProjector(null);

      showMapClickCard("Loading address…");

      // Reverse geocode and update card.
      reverseGeocodeLngLat(e.latlng.lng, e.latlng.lat, undefined)
        .then((label) => showMapClickCard(label || `${e.latlng.lat.toFixed(6)}, ${e.latlng.lng.toFixed(6)}`))
        .catch(() => showMapClickCard(`${e.latlng.lat.toFixed(6)}, ${e.latlng.lng.toFixed(6)}`));
    } catch (_) {
      /* ignore */
    }
  });

  leafletMap.on("draw:editstart", () => {
    document.body.classList.add("leaflet-is-editing");
    // Create mode stays re-armed after each shape; it steals events from edit drag if left enabled.
    stopLeafletDraw();
  });
  leafletMap.on("draw:editstop", () => {
    document.body.classList.remove("leaflet-is-editing");
    if (projectStarted) {
      setTimeout(() => {
        try {
          primeDefaultDrawMode();
        } catch (_) {
          /* ignore */
        }
      }, 0);
    }
  });
  leafletMap.on("draw:deletestart", () => {
    document.body.classList.add("leaflet-is-editing");
    stopLeafletDraw();
  });
  leafletMap.on("draw:deletestop", () => {
    document.body.classList.remove("leaflet-is-editing");
    if (projectStarted) {
      setTimeout(() => {
        try {
          primeDefaultDrawMode();
        } catch (_) {
          /* ignore */
        }
      }, 0);
    }
  });

  if (typeof L.Control.geocoder === "function") {
    // Prefer Photon (fast, good CORS behavior) and fall back to Nominatim.
    // This improves "full address" searches that sometimes return "Nothing found".
    let provider = null;
    if (L.Control.Geocoder) {
      if (typeof L.Control.Geocoder.photon === "function") {
        provider = L.Control.Geocoder.photon({
          // Keep results relevant; Photon already does good ranking.
          geocodingQueryParams: { limit: 8 },
        });
      } else if (typeof L.Control.Geocoder.nominatim === "function") {
        provider = L.Control.Geocoder.nominatim({
          geocodingQueryParams: { limit: 8 },
        });
      }
    }

    const leafletGeocoder = L.Control.geocoder({
      placeholder: dict.geocoderPlaceholder,
      ...(provider ? { geocoder: provider } : {}),
      defaultMarkGeocode: false,
      errorMessage: "Nothing found.",
      position: "topleft",
      queryMinLength: 1,
      suggestMinLength: 2,
      suggestTimeout: 250,
    });
    leafletGeocoder.addTo(leafletMap);
    leafletGeocoder.on("markgeocode", (ev) => {
      const g =
        ev && typeof ev === "object"
          ? ev.geocode ||
            (ev.name && (ev.center || ev.bbox)
              ? ev
              : null)
          : null;
      const label = placeLabelFromLeafletGeocode(g);
      if (label) {
        setProjectPlaceFromSearch(label);
      }
      setTimeout(() => {
        const inp = leafletGeocoder._input;
        if (inp) {
          const v = String(inp.value || "").trim();
          if (v.length >= 4) setProjectPlaceFromSearch(v);
        }
      }, 0);
      const bb = g?.bbox;
      if (bb && typeof bb.isValid === "function" && bb.isValid()) {
        // Zoom into a smaller area; cap max zoom to get close like the reference.
        leafletMap.fitBounds(bb, { maxZoom: MAP_DETAIL_ZOOM });
        const center = bb.getCenter?.();
        if (center) {
          showPickedLocationFromSearch("leaflet", [center.lng, center.lat], label, null);
          setTimeout(() => setProjectorToLngLat([center.lng, center.lat]), 0);
          try {
            if (!projectStarted) {
              if (!leafletSearchMarker) {
                leafletSearchMarker = L.marker(center, { interactive: false });
                leafletSearchMarker.addTo(leafletMap);
              } else {
                leafletSearchMarker.setLatLng(center);
              }
            } else {
              clearProjectPickMarker();
            }
          } catch (_) { /* ignore */ }
        }
      } else if (g?.center) {
        leafletMap.setView(g.center, MAP_DETAIL_ZOOM);
        showPickedLocationFromSearch("leaflet", [g.center.lng, g.center.lat], label, null);
        setTimeout(() => setProjectorToLngLat([g.center.lng, g.center.lat]), 0);
        try {
          if (!projectStarted) {
            if (!leafletSearchMarker) {
              leafletSearchMarker = L.marker(g.center, { interactive: false });
              leafletSearchMarker.addTo(leafletMap);
            } else {
              leafletSearchMarker.setLatLng(g.center);
            }
          } else {
            clearProjectPickMarker();
          }
        } catch (_) { /* ignore */ }
      }
    });

    leafletMap.whenReady(() => {
      const inp = leafletGeocoder._input;
      if (inp && !inp.dataset.mapFenceAddrMirror) {
        inp.dataset.mapFenceAddrMirror = "1";
        inp.setAttribute("autocomplete", "off");
        inp.setAttribute("spellcheck", "false");
        inp.addEventListener("change", () => {
          const v = String(inp.value || "").trim();
          if (v.length >= 4) setProjectPlaceFromSearch(v);
          else if (!v) setProjectPlaceFromSearch("");
        });
      }
    });
  }

  leafletDrawnItems = new L.FeatureGroup();
  leafletMap.addLayer(leafletDrawnItems);

  // Bigger vertex hit targets -> easier "click first point to close" (matches reference UX).
  const drawVertexIcon = new L.DivIcon({
    className: "leaflet-div-icon leaflet-editing-icon map-fence-draw-vertex",
    iconSize: new L.Point(14, 14),
  });
  const drawVertexTouchIcon = new L.DivIcon({
    className: "leaflet-div-icon leaflet-editing-icon leaflet-touch-icon map-fence-draw-vertex",
    iconSize: new L.Point(22, 22),
  });

  const drawControl = new L.Control.Draw({
    position: "topright",
    draw: {
      polyline: {
        guidelineDistance: LEAFLET_DRAW_GUIDELINE_PX,
        shapeOptions: { color: FENCE_DRAW_LINE_COLOR, weight: FENCE_DRAW_LINE_WIDTH_PX, opacity: 0.98 },
        icon: drawVertexIcon,
        touchIcon: drawVertexTouchIcon,
      },
      polygon: {
        allowIntersection: false,
        guidelineDistance: LEAFLET_DRAW_GUIDELINE_PX,
        shapeOptions: {
          color: FENCE_DRAW_LINE_COLOR,
          weight: FENCE_DRAW_LINE_WIDTH_PX,
          opacity: 0.98,
          fillOpacity: FENCE_DRAW_FILL_OPACITY,
        },
        icon: drawVertexIcon,
        touchIcon: drawVertexTouchIcon,
      },
      rectangle: {
        shapeOptions: { color: FENCE_DRAW_LINE_COLOR, weight: FENCE_DRAW_LINE_WIDTH_PX, fillOpacity: FENCE_DRAW_FILL_OPACITY },
      },
      circle: false,
      marker: false,
      circlemarker: false,
    },
    edit: {
      featureGroup: leafletDrawnItems,
      remove: true,
    },
  });
  leafletDrawControlRef = drawControl;
  leafletMap.addControl(drawControl);

  leafletMap.on(L.Draw.Event.CREATED, (e) => {
    // Once the user starts drawing, treat the project as started and hide the click card.
    projectStarted = true;
    hideMapClickCard();
    clearProjectPickMarker();
    // If the user draws point-to-point in Line mode and actually closes back onto
    // the first point, convert the finished polyline into a polygon.
    try {
      const lt = e?.layerType;
      const layer = e?.layer;
      if (lt === "polyline" && layer && typeof layer.getLatLngs === "function") {
        const latlngs = layer.getLatLngs() || [];
        const canClose = Array.isArray(latlngs) && latlngs.length >= 3;
        let shouldClose = false;
        if (canClose && leafletMap?.latLngToContainerPoint) {
          const first = latlngs[0];
          const last = latlngs[latlngs.length - 1];
          try {
            const a = leafletMap.latLngToContainerPoint(first);
            const b = leafletMap.latLngToContainerPoint(last);
            const pxClose = a.distanceTo(b) <= 18;
            // Screen-near is not enough at some zoom levels — require real-world closure too.
            const geoClose = latLngDistanceM(first, last) <= 2.5;
            shouldClose = pxClose && geoClose;
          } catch (_) {
            /* ignore */
          }
        }
        if (canClose && shouldClose) {
          try {
            if (layer && leafletMap?.hasLayer?.(layer)) leafletMap.removeLayer(layer);
          } catch (_) {
            /* ignore */
          }
          const poly = L.polygon(latlngs, {
            color: FENCE_DRAW_LINE_COLOR,
            weight: FENCE_DRAW_LINE_WIDTH_PX,
            fillOpacity: FENCE_DRAW_FILL_OPACITY,
          });
          leafletDrawnItems.addLayer(poly);
          ensureLeafletSectionNameOnLayer(poly);
        } else {
          leafletDrawnItems.addLayer(layer);
          ensureLeafletSectionNameOnLayer(layer);
        }
      } else {
        leafletDrawnItems.addLayer(layer);
        ensureLeafletSectionNameOnLayer(layer);
      }
    } catch (_) {
      leafletDrawnItems.addLayer(e.layer);
      ensureLeafletSectionNameOnLayer(e.layer);
    }
    stopLeafletDraw();
    updateMeasurements();
    saveDraftFenceSoon();
    autoSaveFenceSoon();

    // Immediately re-arm drawing for the next section (so the next click starts drawing).
    // This matches the reference UX where draw mode stays active between sections.
    if (projectStarted) {
      const mode = currentDrawMode || "line";
      const rearm = () => {
        try {
          startLeafletDrawMode(mode);
        } catch (_) {
          /* ignore */
        }
      };
      // Let Leaflet.draw finish internal teardown before enabling the next handler.
      if (typeof requestAnimationFrame === "function") {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setTimeout(rearm, 50);
          });
        });
      } else {
        setTimeout(rearm, 100);
      }
    }
  });
  leafletMap.on(L.Draw.Event.EDITED, () => {
    updateMeasurements();
    saveDraftFenceSoon();
  });
  leafletMap.on(L.Draw.Event.DELETED, () => {
    updateMeasurements();
    saveDraftFenceSoon();
    if (projectStarted && getAllDrawFeatures().length === 0) primeDefaultDrawMode();
  });

  leafletMap.on("mousemove", (ev) => {
    try {
      syncLiveLeafletDrawLength(ev.latlng);
    } catch (_) {
      /* ignore */
    }
  });

  leafletMap.whenReady(() => {
    refreshMapStageProviderClass();
    setSaveStatus(`${dict.mapProviderOSM}`);
    updateMeasurements();
    loadLatestFences().catch(() => renderFenceListPlaceholder());
    scheduleMapGridSync();
    loadDraftFence();
    ensureHelperProjector();
  });
}

function initMapboxMap(token) {
  const dict = STRINGS[appLocale] || STRINGS.en;
  mapboxgl.accessToken = token;
  mapProviderKind = "mapbox";
  leafletBasemapMode = getCheckedGlobalBasemap();

  try {
    map = new mapboxgl.Map({
      container: "map",
      style: MAP_LAYER_URLS.mapbox[leafletBasemapMode] || MAP_LAYER_URLS.mapbox.satelliteStreets,
      center: HOME_VIEW.center,
      zoom: HOME_VIEW.zoom,
      projection: "mercator",
      maxZoom: MAP_MAX_ZOOM,
    });
  } catch (err) {
    console.error(err);
    setSaveStatus(`${dict.mapLoadError} ${err?.message || err}`);
    throw err;
  }

  map.on("error", (e) => {
    console.error(e);
    const msg = e?.error?.message || String(e?.error || e);
    setSaveStatus(`${dict.mapLoadError} ${msg}`);
  });

  map.addControl(
    new mapboxgl.NavigationControl({
      visualizePitch: true,
    }),
    "top-right"
  );

  // Geocoder plugin may fail to load (offline/CDN blocked) — keep the map usable.
  try {
    if (typeof MapboxGeocoder === "function") {
      const geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl,
        placeholder: dict.geocoderPlaceholder,
        // We manage the "pick" marker ourselves (and remove it after Start Project).
        marker: false,
        autocomplete: true,
        fuzzyMatch: true,
        minLength: 2,
        limit: 6,
      });
      map.addControl(geocoder, "top-left");
      wireMapboxGeocoderProjectAddress(map, geocoder);
    } else {
      console.warn("MapboxGeocoder is not available.");
    }
  } catch (err) {
    console.error("Geocoder init failed:", err);
  }
  bindKeyboardShortcuts();
  bindMapboxRotateGesture();
  bindStartProjectButton();
  bindHomeButton();
  hideMapClickCard();

  // Draw plugin may fail to load (offline/CDN blocked). If missing, the app should still work (click + start project).
  try {
    if (typeof MapboxDraw === "function") {
      // Mapbox GL JS v2.x can reject MapboxDraw v1.5.x default styles because line-dasharray
      // arrays are validated as expressions. Wrap raw arrays using ["literal", ...].
      // Ref: `mapbox-gl-draw` issue about gl-draw-lines.* line-dasharray validation.
      const safeDrawStyles = (() => {
        try {
          const base = MapboxDraw.styles;
          if (!Array.isArray(base)) return undefined;
          return base.map((s) => {
            if (!s || typeof s !== "object") return s;
            const paint = s.paint;
            if (!paint || typeof paint !== "object") return s;
            const id = String(s.id || "");
            if (!id.includes("gl-draw")) return s;

            // The default theme uses an expression for line-dasharray that fails strict validation
            // in Mapbox GL JS v2.15. Removing it keeps Draw functional.
            const nextPaint = { ...paint };
            if (Object.prototype.hasOwnProperty.call(nextPaint, "line-dasharray")) {
              delete nextPaint["line-dasharray"];
            }
            const layerType = s.type;
            if (layerType === "line") {
              nextPaint["line-color"] = FENCE_DRAW_LINE_COLOR;
              nextPaint["line-width"] = FENCE_DRAW_LINE_WIDTH_PX;
            } else if (layerType === "fill") {
              nextPaint["fill-color"] = FENCE_DRAW_LINE_COLOR;
              nextPaint["fill-opacity"] = FENCE_DRAW_FILL_OPACITY;
              nextPaint["fill-outline-color"] = FENCE_DRAW_LINE_COLOR;
            } else if (layerType === "circle") {
              nextPaint["circle-color"] = FENCE_DRAW_VERTEX_FILL;
              nextPaint["circle-stroke-color"] = FENCE_DRAW_VERTEX_STROKE;
              nextPaint["circle-stroke-width"] = FENCE_DRAW_VERTEX_STROKE_PX;
              const cr = Number(nextPaint["circle-radius"]);
              nextPaint["circle-radius"] = Number.isFinite(cr)
                ? Math.max(cr, MAPBOX_DRAW_MIN_VERTEX_RADIUS_PX)
                : MAPBOX_DRAW_MIN_VERTEX_RADIUS_PX;
            }
            const out = { ...s, paint: nextPaint };
            if (layerType === "line") {
              out.layout = {
                ...(s.layout && typeof s.layout === "object" ? s.layout : {}),
                "line-cap": "round",
                "line-join": "round",
              };
            }
            return out;
          });
        } catch (_) {
          return undefined;
        }
      })();

      const customModes = (() => {
        // mapboxGLDrawRectangleDrag is a browser global exported by the rectangle-drag plugin (index.html).
        // If it's missing, we fall back to plain modes (rectangle button will behave like polygon).
        try {
          if (typeof mapboxGLDrawRectangleDrag !== "undefined") {
            return { ...MapboxDraw.modes, draw_rectangle_drag: mapboxGLDrawRectangleDrag };
          }
        } catch (_) {
          /* ignore */
        }
        return MapboxDraw.modes;
      })();

      draw = new MapboxDraw({
        defaultMode: projectStarted
          ? (currentDrawMode === "line" ? "draw_line_string" : "draw_polygon")
          : "simple_select",
        displayControlsDefault: false,
        modes: customModes,
        ...(safeDrawStyles ? { styles: safeDrawStyles } : {}),
        controls: {
          line_string: false,
          polygon: false,
          trash: true,
        },
      });
      map.addControl(draw, "top-left");
      // Ensure draw mode is armed once the map style is ready.
      map.once("load", () => ensureMapboxDrawArmed());
      map.once("idle", () => ensureMapboxDrawArmed());
      map.once("idle", () => {
        try {
          enforceMapboxDrawLinePaint();
        } catch (_) {
          /* ignore */
        }
      });
    } else {
      draw = null;
      console.warn("MapboxDraw is not available.");
      // Drawing is a core feature of this app. If Draw isn't available, force fallback provider.
      setSaveStatus(`${dict.mapLoadError} Mapbox Draw failed to load (cannot draw).`);
      throw new Error("MapboxDraw not loaded");
    }
  } catch (err) {
    console.error("Draw init failed:", err);
    draw = null;
    // Throw so initMap() can fall back to Leaflet.
    throw err;
  }

  map.on("draw.create", (e) => {
    snapshotMapboxUndoState();
    const createdId = e.features?.[0]?.id;
    setTimeout(() => {
      try {
        if (createdId && draw) {
          const f = getMapboxDrawFeatureById(createdId);
          if (f) {
            const sn = f.properties?.sectionName;
            const hasName = sn && String(sn).trim();
            const pNum = Number(f.properties?.uprightSpacingM);
            const hasSp = pNum === 3 || pNum === 4;
            if (!hasName || !hasSp) {
              draw.delete(createdId);
              mapboxDrawAddCleanFeature(f.geometry, {
                ...(f.properties || {}),
                sectionName: hasName ? String(sn).trim() : nextAutoSectionName(),
                uprightSpacingM: hasSp ? pNum : uprightSpacingM,
              });
            }
          }
        }
      } catch (err) {
        console.warn(err);
      }
      updateMeasurements();
      saveDraftFenceSoon();
      autoSaveFenceSoon();
      if (projectStarted) {
        const mode = currentDrawMode || "line";
        setTimeout(() => {
          try {
            mapboxSetDrawMode(mode);
          } catch (_) {
            /* ignore */
          }
        }, 0);
      }
    }, 0);
  });
  map.on("draw.update", () => {
    snapshotMapboxUndoState();
    updateMeasurements();
    saveDraftFenceSoon();
    try {
      syncLiveDrawLengthLabel(null);
    } catch (_) {
      /* ignore */
    }
  });
  map.on("draw.modechange", () => {
    try {
      syncLiveDrawLengthLabel(null);
    } catch (_) {
      /* ignore */
    }
  });
  map.on("draw.delete", () => {
    snapshotMapboxUndoState();
    updateMeasurements();
    saveDraftFenceSoon();
    if (projectStarted && getAllDrawFeatures().length === 0) primeDefaultDrawMode();
  });

  map.on("load", () => {
    // Seed undo history with initial empty state.
    try {
      mapboxUndoStack = [];
      snapshotMapboxUndoState();
    } catch (_) {
      /* ignore */
    }
    scheduleMapGridSync();
    refreshMapStageProviderClass();
    if (activeNlOrthoYear) addMapboxOrthoLayer(activeNlOrthoYear);
    setSaveStatus(STRINGS[appLocale]?.saveStatusReady || STRINGS.en.saveStatusReady);
    updateMeasurements();
    loadLatestFences().catch(() => {
      renderFenceListPlaceholder();
    });
    if (projectStarted) primeDefaultDrawMode();
    loadDraftFence();
    ensureHelperProjector();
    try {
      enforceMapboxDrawLinePaint();
    } catch (_) {
      /* ignore */
    }
  });

  map.on("click", async (e) => {
    try {
      const oe = e?.originalEvent;
      if (
        oe?.target &&
        (oe.target.closest?.(".calc-panel") ||
          oe.target.closest?.(".mapboxgl-ctrl") ||
          oe.target.closest?.(".bottom-toolbar") ||
          oe.target.closest?.(".map-layers-wrap"))
      ) {
        return;
      }

      // Alt + click on (near) a vertex removes that point (Mapbox implementation).
      if (oe?.altKey) {
        const ok = removeNearestMapboxVertexAt(e.point);
        if (ok) {
          updateMeasurements();
          saveDraftFenceSoon();
          autoSaveFenceSoon();
          return;
        }
      }

      const ll = e?.lngLat;
      if (!ll) return;
      lastClickedLngLat = [ll.lng, ll.lat];

      // Only show the picked-location pin BEFORE starting the project.
      if (!projectStarted) {
        if (!mapboxSearchMarker) {
          mapboxSearchMarker = new mapboxgl.Marker({ color: "#e53935" }).setLngLat(lastClickedLngLat).addTo(map);
        } else {
          mapboxSearchMarker.setLngLat(lastClickedLngLat);
        }
      } else {
        clearProjectPickMarker();
      }
      if (projectStarted && buildingDetectionActive) {
        const detected = await tryDetectBuildingAtClick([ll.lng, ll.lat]);
        if (detected) { hideMapClickCard(); return; }
      }

      if (projectStarted) {
        try {
          const dm = draw?.getMode?.();
          if (dm && String(dm).startsWith("draw_")) {
            try {
              ensureHelperProjector();
              updateHelperProjector([ll.lng, ll.lat]);
            } catch (_) {
              /* ignore */
            }
            hideMapClickCard();
            return;
          }
        } catch (_) {
          /* ignore */
        }
        // If drawing is expected but not armed, arm it now (prevents "projector moves but no line" state).
        ensureMapboxDrawArmed();
        setProjectorToLngLat(lastClickedLngLat);
        hideMapClickCard();
        return;
      }

      // Before Start Project: do not run projector/drawing yet, only show the card + pin.
      updateHelperProjector(null);

      showMapClickCard("Loading address…");

      reverseGeocodeLngLat(ll.lng, ll.lat, undefined)
        .then((label) => showMapClickCard(label || `${ll.lat.toFixed(6)}, ${ll.lng.toFixed(6)}`))
        .catch(() => showMapClickCard(`${ll.lat.toFixed(6)}, ${ll.lng.toFixed(6)}`));
    } catch (_) {
      /* ignore */
    }
  });

  map.on("mousemove", (e) => {
    try {
      if (e?.lngLat) syncLiveDrawLengthLabel(e.lngLat);
    } catch (_) {
      /* ignore */
    }
  });
}

async function initMap() {
  const token = getEffectiveMapboxToken();
  bindMapResize();

  const dict = STRINGS[appLocale] || STRINGS.en;

  // Prefer Mapbox when configured, but don't let a broken CDN/plugin hard-break the app.
  if (token && typeof mapboxgl !== "undefined") {
    try {
      initMapboxMap(token);
      return;
    } catch (err) {
      console.error("Mapbox init failed; falling back to Leaflet:", err);
      setSaveStatus(`${dict.mapLoadError} Mapbox failed to start, using fallback map.`);
    }
  } else if (!token) {
    setSaveStatus(dict.mapboxTokenHint || "Missing Mapbox token.");
  } else {
    setSaveStatus(`${dict.mapLoadError} Mapbox GL JS not loaded.`);
  }

  try {
    await loadLeafletDeps();
    initLeafletMap();
  } catch (err) {
    console.error(err);
    setSaveStatus(`${dict.mapLoadError} ${err}\n${dict.mapboxTokenHint}`);
  }
}

async function saveFence(opts = {}) {
  const silent = !!opts.silent;
  if (!hasMap()) {
    if (!silent) setSaveStatus(STRINGS[appLocale]?.saveStatusNoMap || STRINGS.en.saveStatusNoMap);
    return;
  }

  const features = getAllDrawFeatures();
  if (features.length === 0) {
    if (!silent) setSaveStatus(STRINGS[appLocale]?.saveStatusNoFence || STRINGS.en.saveStatusNoFence);
    return;
  }

  const dict = STRINGS[appLocale] || STRINGS.en;
  const geojson =
    features.length === 1 ? features[0] : { type: "FeatureCollection", features: [...features] };
  const calcs = getCurrentCalculations();
  const sectionName = getSectionName();
  const geometrySig = geometrySignatureSetFromSavedRoot(geojson);
  const nowMs = Date.now();

  // Prevent accidental double-saves (autosave + manual click, double-click, etc.)
  // If geometry did not change and we saved moments ago, skip creating another entry.
  if (geometrySig && geometrySig === lastSavedGeometrySig && nowMs - lastSavedAtMs < 2500) {
    if (!silent) setSaveStatus(dict.saveStatusSaved);
    return;
  }

  const payload = {
    locale: appLocale,
    geojson,
    sectionName,
    uprightSpacingM,
    calculations: calcs,
  };

  let cloudOk = false;
  if (firestore) {
    try {
      await firestore.collection("fences").add({
        ...payload,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      });
      cloudOk = true;
      lastSavedGeometrySig = geometrySig || lastSavedGeometrySig;
      lastSavedAtMs = nowMs;
    } catch (err) {
      console.error(err);
      setSaveStatus(`${dict.saveStatusSaveFailed}\n${err?.message || err}`);
    }
  }

  let localOk = false;
  if (!cloudOk) {
    try {
      const localRecord = {
        id:
          typeof crypto !== "undefined" && crypto.randomUUID
            ? crypto.randomUUID()
            : `local-${Date.now()}`,
        ...payload,
        createdAt: new Date().toISOString(),
      };
      const items = readLocalFences();

      // De-dupe local saves by geometry signature (so the same fence isn't listed twice).
      const sig = geometrySig || geometrySignatureSetFromSavedRoot(localRecord.geojson);
      const pruned = sig
        ? items.filter((x) => geometrySignatureSetFromSavedRoot(x?.geojson) !== sig)
        : items;

      pruned.unshift(localRecord);
      lastSavedGeometrySig = sig || lastSavedGeometrySig;
      lastSavedAtMs = nowMs;
      writeLocalFences(pruned);
      localOk = true;
    } catch (err) {
      console.error(err);
    }
  }

  if (cloudOk) {
    if (!silent) setSaveStatus(dict.saveStatusSaved);
  } else if (localOk) {
    if (!silent) setSaveStatus(!firestore ? dict.saveStatusSavedLocal : `${dict.saveStatusSavedLocal}`);
  } else {
    setSaveStatus(`${dict.saveStatusSaveFailed}\n${!firestore ? "Configure Firebase or allow browser storage." : ""}`);
  }

  await loadLatestFences();
}

function getFirstFeatureFromDraw() {
  return getAllDrawFeatures()[0] || null;
}

function applyLoadedFenceMeta(data) {
  if (!data) return;
  // Only apply `sectionName` meta when there is exactly one feature.
  // Otherwise we'd overwrite the first section name and break numbering on reload.
  if (data.sectionName) {
    const feats = getAllDrawFeatures();
    if (feats.length === 1) {
      const f0 = feats[0];
      if (f0 && draw && f0.id != null) {
        updateMapboxFeatureProperties(f0.id, { sectionName: data.sectionName });
      } else if (f0 && leafletDrawnItems) {
        updateLeafletLayerGeojsonAtIndex(0, { sectionName: data.sectionName });
      }
    }
  }
  const sp = Number(data.uprightSpacingM || data.calculations?.uprightSpacingM);
  if (sp === 3 || sp === 4) {
    uprightSpacingM = sp;
    document.querySelectorAll('input[name="uprightSpacing"]').forEach((r) => {
      r.checked = Number(r.value) === uprightSpacingM;
    });
    try {
      localStorage.setItem(SPACING_STORAGE_KEY, String(uprightSpacingM));
    } catch (_) {
      /* ignore */
    }
  }
}

function renderFenceEntries(entries, dict) {
  const list = document.getElementById("fenceList");
  if (!list) return;
  list.innerHTML = "";
  lastFenceListEntries = entries;
  lastFenceListDict = dict;

  const pairs = entries
    .map((entry, origIdx) => ({ entry, origIdx }))
    .filter(({ entry }) => !savedEntryDuplicatesActiveDraw(entry));

  if (pairs.length === 0 && entries.length > 0) {
    list.innerHTML = `<div class="fence-list-empty">${escapeHtml(
      dict.savedBoundariesNoExtra || STRINGS.en.savedBoundariesNoExtra
    )}</div>`;
    return;
  }

  const rowKeys = new Set(pairs.map(({ entry, origIdx }) => fenceEntryStableKey(entry, origIdx)));
  if (highlightedFenceListKey && !rowKeys.has(highlightedFenceListKey)) {
    highlightedFenceListKey = null;
  }

  pairs.forEach(({ entry, origIdx }) => {
    const idx = origIdx;
    const feature = entry.geojson;
    const dateStr = entry.dateStr || "—";
    const label = entry.sectionName || `${dict.fenceItemLabel} ${idx + 1}`;
    const len = formatFenceLengthCompact(entry.calculations?.perimeterM);
    const rowKey = fenceEntryStableKey(entry, idx);
    const isShown = highlightedFenceListKey === rowKey;
    const eyeIcon = isShown ? "mdi-eye" : "mdi-eye-off";
    const eyeLabel = isShown ? dict.hideFenceBtn || dict.loadFenceBtn : dict.loadFenceBtn;

    const item = document.createElement("div");
    item.className = `fence-item${isShown ? " fence-item--active" : ""}`;
    item.dataset.fenceKey = rowKey;
    item.title = dateStr !== "—" ? `${label} — ${dateStr}` : label;

    item.innerHTML = `
      <span class="fence-item__name">${escapeHtml(label)}</span>
      <span class="fence-item__length">${escapeHtml(len)}</span>
      <div class="fence-item__actions">
        <button type="button" class="fence-icon-btn fence-icon-btn--view loadFenceBtn${isShown ? " is-pressed" : ""}" title="${escapeHtml(
          eyeLabel
        )}" aria-label="${escapeHtml(eyeLabel)}" aria-pressed="${isShown ? "true" : "false"}">
          <span class="mdi ${eyeIcon}" aria-hidden="true"></span>
        </button>
        <button type="button" class="fence-icon-btn fence-icon-btn--delete deleteFenceBtn" title="${escapeHtml(
          dict.deleteFenceBtn
        )}" aria-label="${escapeHtml(dict.deleteFenceBtn)}">
          <span class="mdi mdi-trash-can-outline" aria-hidden="true"></span>
        </button>
      </div>
    `;

    const loadBtn = item.querySelector(".loadFenceBtn");
    loadBtn.addEventListener("click", (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      if (!feature) return;
      const k = fenceEntryStableKey(entry, idx);
      if (highlightedFenceListKey === k) {
        highlightedFenceListKey = null;
        if (draw) {
          draw.deleteAll();
          primeDefaultDrawMode();
        } else if (leafletMap && leafletDrawnItems) {
          stopLeafletDraw();
          leafletDrawnItems.clearLayers();
          primeDefaultDrawMode();
        }
        updateMeasurements();
        refreshFenceListUI();
        return;
      }
      highlightedFenceListKey = k;
      projectStarted = true;
      hideMapClickCard();
      clearProjectPickMarker();
      if (draw) {
        addFeaturesToMapboxDraw(feature, { modeAfter: "simple_select" });
      } else {
        loadGeojsonOntoLeaflet(feature, { skipArmDraw: true });
      }
      applyLoadedFenceMeta(entry.raw || entry);
      normalizeAutoSectionNamesAfterLoad();
      updateMeasurements();
      refreshFenceListUI();
    });

    const deleteBtn = item.querySelector(".deleteFenceBtn");
    deleteBtn.addEventListener("click", async () => {
      const k = fenceEntryStableKey(entry, idx);
      if (highlightedFenceListKey === k) {
        highlightedFenceListKey = null;
        if (draw) {
          draw.deleteAll();
          primeDefaultDrawMode();
        } else if (leafletMap && leafletDrawnItems) {
          stopLeafletDraw();
          leafletDrawnItems.clearLayers();
          primeDefaultDrawMode();
        }
      }
      try {
        if (entry.source === "firestore" && firestore && entry.docId) {
          await firestore.collection("fences").doc(entry.docId).delete();
        } else if (entry.source === "local" && entry.localId) {
          const items = readLocalFences().filter((x) => x.id !== entry.localId);
          writeLocalFences(items);
        }
      } catch (err) {
        console.error(err);
        setSaveStatus(`${dict.saveStatusSaveFailed}\n${err?.message || err}`);
      }
      await loadLatestFences();
    });

    list.appendChild(item);
  });
}

async function loadLatestFences() {
  const dict = STRINGS[appLocale] || STRINGS.en;

  if (firestore) {
    try {
      let docs = [];
      try {
        const snap = await firestore.collection("fences").orderBy("createdAt", "desc").limit(10).get();
        docs = snap.docs || [];
      } catch (orderErr) {
        console.warn("Firestore orderBy failed, fetching without sort:", orderErr);
        const snap = await firestore.collection("fences").limit(30).get();
        docs = (snap.docs || []).sort((a, b) => {
          const da = a.data()?.createdAt?.toDate?.()?.getTime?.() || 0;
          const db = b.data()?.createdAt?.toDate?.()?.getTime?.() || 0;
          return db - da;
        });
        docs = docs.slice(0, 10);
      }

      if (docs.length > 0) {
        const entries = docs.map((doc) => {
          const data = doc.data();
          const createdAt = data?.createdAt;
          const dateStr = createdAt?.toDate ? createdAt.toDate().toLocaleString() : "—";
          return {
            source: "firestore",
            docId: doc.id,
            geojson: data.geojson,
            sectionName: data.sectionName,
            calculations: data.calculations,
            uprightSpacingM: data.uprightSpacingM,
            dateStr,
            raw: data,
          };
        });
        renderFenceEntries(entries, dict);
        return;
      }
    } catch (err) {
      console.error(err);
    }
  }

  const local = readLocalFences().slice(0, 10);
  if (local.length === 0) {
    renderFenceListPlaceholder(dict.fencesEmpty);
    return;
  }

  const entries = local.map((row) => ({
    source: "local",
    localId: row.id,
    geojson: row.geojson,
    sectionName: row.sectionName,
    calculations: row.calculations,
    uprightSpacingM: row.uprightSpacingM,
    dateStr: row.createdAt ? new Date(row.createdAt).toLocaleString() : "—",
    raw: row,
  }));
  renderFenceEntries(entries, dict);
}

function bindUI() {
  const clearBtn = document.getElementById("clearBtn");
  const saveBtn = document.getElementById("saveBtn");
  const sendBtn = document.getElementById("sendRequestBtn");
  const contactModalClose = document.getElementById("contactModalClose");

  clearBtn?.addEventListener("click", () => {
    stopLeafletDraw();
    draw?.deleteAll?.();
    leafletDrawnItems?.clearLayers?.();
    // Reset the "pick location -> Start Project" flow so the card can appear again.
    projectStarted = false;
    lastClickedLngLat = null;
    lastResolvedPlaceName = "";
    refreshProjectPlaceAddress();
    clearProjectPickMarker();
    updateHelperProjector(null);
    updateMeasurements();
    primeDefaultDrawMode();
    try { localStorage.removeItem(DRAFT_FENCE_KEY); } catch (_) { /* ignore */ }
    const dict = STRINGS[appLocale] || STRINGS.en;
    setSaveStatus(leafletMap ? dict.mapProviderOSM : dict.saveStatusReady);
  });

  saveBtn?.addEventListener("click", () => {
    saveFence().catch((err) => {
      console.error(err);
      setSaveStatus(`${STRINGS[appLocale]?.saveStatusSaveFailed || STRINGS.en.saveStatusSaveFailed}\n${err}`);
    });
  });

  // Popup functionality removed; keep button visible only when fencing is complete.
  sendBtn?.addEventListener("click", () => {
    setContactModalOpen(true);
  });

  // Quote Button Click Handler
document.getElementById("requestQuoteBtn")?.addEventListener("click", () => {
  const all = getAllDrawFeatures ? getAllDrawFeatures() : [];
  if (!all.length) {
    alert("Bitte zeichne mindestens einen Bereich auf der Karte.");
    return;
  }
  
  const quoteData = {
    location: projectPlace || "Unbenanntes Projekt",
    windZone: currentWindZone,
    uprightType: uprightType,
    sections: all.map(f => {
      const calc = getCalculationsForSingleFeature(f);
      return {
        name: f.properties?.sectionName || "Bereich",
        length: calc?.perimeterM || 0,
        uprights: calc?.uprights || 0,
        railings4m: calc?.sets4m || 0,
        railings3m: calc?.sets3m || 0,
        uprightSpacing: getSegmentUprightSpacingM(f)
      };
    })
  };
  
  showQuoteModal(quoteData);
});

function showQuoteModal(data) {
  const modal = document.getElementById("quoteModal");
  const body = document.getElementById("quoteModalBody");
  
  // Berechne Gesamtsummen
  const totals = {
    uprights: data.sections.reduce((sum, s) => sum + s.uprights, 0),
    railings4m: data.sections.reduce((sum, s) => sum + s.railings4m, 0),
    railings3m: data.sections.reduce((sum, s) => sum + s.railings3m, 0),
    length: data.sections.reduce((sum, s) => sum + s.length, 0)
  };
  
  body.innerHTML = `
    <div class="quote-summary">
      <h3>${data.location}</h3>
      <p><strong>Windzone:</strong> ${data.windZone?.zone || "—"}</p>
      <p><strong>Ständer-Typ:</strong> ${data.uprightType}</p>
      
      <hr style="margin: 15px 0; border: none; border-top: 1px solid #eee;"/>
      
      <h4>Materialübersicht:</h4>
      <table class="quote-table">
        <tr>
          <td>Gesamtlänge:</td>
          <td><strong>${totals.length.toFixed(1)} m</strong></td>
        </tr>
        <tr>
          <td>Ständer (Uprights):</td>
          <td><strong>${totals.uprights}</strong> Stück</td>
        </tr>
        <tr>
          <td>Schienen 4m:</td>
          <td><strong>${totals.railings4m}</strong> Stück</td>
        </tr>
        <tr>
          <td>Schienen 3m:</td>
          <td><strong>${totals.railings3m}</strong> Stück</td>
        </tr>
      </table>
    </div>
  `;
  
  modal.hidden = false;
}

// Quote Modal Close
document.getElementById("quoteModalClose")?.addEventListener("click", () => {
  document.getElementById("quoteModal").hidden = true;
});

// Quote Absenden
document.getElementById("sendQuoteBtn")?.addEventListener("click", () => {
  const modal = document.getElementById("quoteModal");
  const form = document.getElementById("ContactForm-map-fencing");
  
  if (form) {
    const formData = new FormData(form);
    formData.append("quote[uprightType]", uprightType);
    formData.append("quote[windZone]", currentWindZone?.zone || "");
    
    // Form absenden
    form.submit();
  }
  
  modal.hidden = true;
});

  const wireContactForm = () => {
    const formEl = getContactModalForm();
    if (!formEl || formEl.dataset.bound === "1") return;
    formEl.dataset.bound = "1";
    formEl.addEventListener("submit", () => {
      syncContactFenceFieldsIntoForm(formEl);
      formEl.setAttribute("target", "_top");
      sendBtn.hidden = true;
      setContactModalOpen(false);
      resetCurrentFencingAfterQuote();
      const status = document.getElementById("contactFormStatus");
      if (status) status.textContent = "Submitting...";
    });
  };
  // Modal form may be rendered by Shopify; try to wire now and again on open.
  wireContactForm();

  const closeModal = () => setContactModalOpen(false);
  contactModalClose?.addEventListener("click", closeModal);
  document.getElementById("contactModal")?.addEventListener("click", (ev) => {
    if (ev.target && ev.target.id === "contactModal") closeModal();
  });
  document.addEventListener("keydown", (ev) => {
    if (ev.key === "Escape") closeModal();
  });

  const clearAllBtn = document.getElementById("clearAllDrawingsBtn");
  clearAllBtn?.addEventListener("click", () => {
    const dict = STRINGS[appLocale] || STRINGS.en;
    stopLeafletDraw();
    draw?.deleteAll?.();
    leafletDrawnItems?.clearLayers?.();
    segmentFoldOpenByKey = {};
    projectStarted = false;
    lastClickedLngLat = null;
    lastResolvedPlaceName = "";
    refreshProjectPlaceAddress();
    clearProjectPickMarker();
    updateHelperProjector(null);
    updateMeasurements();
    primeDefaultDrawMode();
    try {
      localStorage.removeItem(DRAFT_FENCE_KEY);
    } catch (_) {
      /* ignore */
    }
    hideLiveDrawLengthMarker();
    hideLiveLeafletLengthMarker();
    setSaveStatus(leafletMap ? dict.mapProviderOSM : dict.saveStatusReady);
  });
}

async function start() {
  applyI18n();
  initLanguageSelect();
  initUprightSpacingControls();
  initMapLayerControls();
  renderFenceListPlaceholder();
  bindUI();
  resetQuoteStateFromSuccessUrl();
  updateSendRequestButtonVisibility();

  setSaveStatus(STRINGS[appLocale]?.saveStatusReady || STRINGS.en.saveStatusReady);

  await initFirebase();
  await initMap();
  observeMapContainerResize();
  scheduleMapGridSync();
  syncMapLayerCheckboxesFromState();
  refreshMapStageProviderClass();
  initDrawToolbar();
  if (projectStarted) primeDefaultDrawMode();
  initBuildingDetection();
}

start().catch((err) => console.error(err));

